// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("./i/main_1_leto_bg_grad.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("./i/bg_download1_mobile.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("./i/glow_bg_coins.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("./i/glow_bg_coins_small.svg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*reset all*/
*,
*::before,
*::after {
  box-sizing: border-box;
  vertical-align: baseline;
  font-weight: inherit;
  font-family: inherit;
  font-style: inherit;
  font-size: 100%;
  border: 0 none;
  outline: 0;
  padding: 0;
  margin: 0;
}

ul[class],
ol[class] {
  padding: 0;
}

body,
h1,
h2,
h3,
h4,
p,
ul[class],
ol[class],
li,
figure,
figcaption,
blockquote,
dl,
dd {
  margin: 0;
}

H1, H2, H3, H4, H5, H6 {
  font-size: inherit;
  line-height: inherit;
  font-weight: inherit;
  margin: 0;
  padding: 0;
}

body {
  min-height: 100vh;
  scroll-behavior: smooth;
  text-rendering: optimizeSpeed;
  line-height: 1.5;
}

ul[class],
ol[class] {
  list-style: none;
}

a:not([class]) {
  text-decoration-skip-ink: auto;
}

img {
  max-width: 100%;
  display: block;
}

article > * + * {
  margin-top: 1em;
}

input,
button,
textarea,
select {
  font: inherit;
}

A {
  outline: none;
  text-decoration: none;
}

INPUT, TEXTAREA {
  outline: none;
}

/*end reset all*/
/*colors*/
/*end of colors*/
body > iframe {
  display: none;
}

:root {
  --font-family: "fs_eliot";
  --second-family: "goodtimes";
  --third-family: "Atom-Regular";
  --font3: "Atom-Regular";
}

@keyframes fadeIn {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}
@keyframes deColor {
  0% {
    filter: brightness(1);
  }
  50% {
    filter: brightness(1.75);
  }
  100% {
    filter: brightness(1);
  }
}
@keyframes deColor1 {
  0% {
    filter: brightness(1);
  }
  16.5% {
    filter: brightness(1.75);
  }
  33% {
    filter: brightness(1);
  }
}
@keyframes deColor2 {
  33% {
    filter: brightness(1);
  }
  49.5% {
    filter: brightness(1.75);
  }
  66% {
    filter: brightness(1);
  }
}
@keyframes deColor3 {
  66% {
    filter: brightness(1);
  }
  82.5% {
    filter: brightness(1.75);
  }
  100% {
    filter: brightness(1);
  }
}
body {
  background-color: #CCCF2C; /*#1E1E1E*/
  color: #040628;
  /*
  background-image:url('/i/bg_footer.svg');
  background-repeat:no-repeat;
  background-size:contain;*/
}

.show {
  opacity: 1 !important;
}

.disable_scroll {
  overflow: hidden;
}

.hide {
  display: none !important;
}

.head_block {
  position: relative;
  /*background-image:url('/i/black_hole 2.png');*/
  background-repeat: no-repeat;
  background-size: 100vw; /*100vw, 100%/
/*border-bottom:1px solid rgba(255,255,255,0.2);*/
  /*background: linear-gradient(0deg, #cccf2c 0%, #fdff8a 100%);*/
  /*background: linear-gradient(0deg, rgba(204,207,44, 0.5) 0%, rgba(253,255,138, 0.5) 100%);*/
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-position: center; /*center 0%, center*/
  min-height: 624px;
}

.head_bg {
  position: absolute;
  top: 0px;
  left: 0px;
  background: linear-gradient(0deg, rgba(204, 207, 44, 0) 0%, rgba(253, 255, 138, 0.5) 100%); /*background: linear-gradient(0deg, rgba(204,207,44, 0.5) 0%, rgba(253,255,138, 0.5) 100%);*/
  background-size: 100%;
  width: 100%;
  height: 70%;
}

.head_block_1 {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  padding-top: 159px;
  /*background-image: url('/i/main_1_leto_bg.png');*/
  background-repeat: no-repeat;
  background-size: clamp(500px, 100%, 1031px);
  background-position: center 243px; /*235 151*/
}
.head_block_1 .title {
  font-family: var(--second-family);
  font-size: 70px;
  line-height: 76%;
  color: #fbff6c;
}
.head_block_1 .head_block_text_img {
  width: 100%;
  max-width: 1061px;
  margin-top: 15px;
}

.head_block_1_wrapper {
  position: relative;
  top: -27px; /*-30*/
  /*top:-220px; -220px*/
  display: flex;
  justify-content: center;
  align-items: flex-end;
}
.head_block_1_wrapper .small_image {
  display: flex;
  align-items: flex-end;
  margin-bottom: 40px;
}
.head_block_1_wrapper .small_image .title {
  font-family: var(--font3);
  font-weight: 400;
  font-size: 27px;
  line-height: 100%;
  color: #040628;
}
.head_block_1_wrapper .small_image IMG {
  max-height: 89px;
  height: 100%;
}
.head_block_1_wrapper .column_1 {
  position: relative;
  left: max(8%, 21px); /*10% 127px*/
  flex-shrink: 0;
}
.head_block_1_wrapper .column_1 IMG {
  margin-right: 18px;
}
.head_block_1_wrapper .column_2 IMG {
  max-height: max(100vh - 298px, 300px); /*100vh - 268px  740px*/
  /*	min-height:300px;*/
}
.head_block_1_wrapper .column_3 {
  position: relative;
  right: max(8%, 21px); /*10% 127px*/
  flex-shrink: 0;
}
.head_block_1_wrapper .column_3 .title {
  text-align: right;
}
.head_block_1_wrapper .column_3 IMG {
  margin-left: 6px;
}

.head_block_2 {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  position: relative;
  margin-top: 33px;
  overflow: visible;
  z-index: 0;
}
.head_block_2 .text {
  font-family: "Atom-Light";
  font-size: 24px;
  line-height: 29px;
  text-align: center;
  color: #040628;
  max-width: 959px;
  padding-left: 46px;
  padding-right: 46px;
}
.head_block_2 .text SPAN {
  font-family: "Atom-Bold";
}

/*responsive header*/
@media all and (max-width: 1109px) {
  .head_block_1 {
    padding-top: 100px;
    background: none;
  }
  .head_block_1 .title {
    font-size: 32px; /*40*/
    line-height: 100%;
    color: #fbff6c;
    text-align: center;
    padding-left: 0px;
    padding-right: 30px;
  }
  .head_block_1 .title:first-child {
    padding-left: 30px;
    padding-right: 0px;
  }
  .head_block_1_wrapper {
    top: 0px;
    margin-top: 15px; /*24*/
  }
  .head_block_text_img {
    display: none;
  }
}
@media all and (max-width: 991px) {
  .head_block_1_wrapper .small_image .title {
    font-size: 21px;
    line-height: 105%;
    color: #040628;
    text-align: right;
    padding-left: 0px;
    padding-right: 0px;
  }
  .head_block_1_wrapper .column_1 {
    left: 30px;
  }
  .head_block_1_wrapper .column_3 {
    right: 30px;
  }
  .head_block_1_wrapper .column_1 IMG {
    max-height: 71px;
    margin-right: 14px;
  }
  .head_block_1_wrapper .column_2 IMG {
    max-height: unset;
  }
  .head_block_1_wrapper .column_3 IMG {
    max-height: 73px;
    margin-left: 5px;
  }
  .head_block_2 .text {
    font-size: 14px;
    line-height: 1.25;
    color: #040628;
    padding-left: 30px;
    padding-right: 30px;
  }
}
@media all and (max-width: 750px) {
  .head_block_1 .title {
    text-align: left;
  }
  .head_block_1_wrapper {
    flex-direction: column;
    align-items: center;
  }
  .head_block_1_wrapper .column_1 {
    order: 2;
    left: unset;
    align-self: flex-start;
    padding-left: 28px;
  }
  .head_block_1_wrapper .column_2 {
    order: 1; /*
height:50vh;
width:100vw;
background-image: url('/i/main_bg_mob.png');
background-repeat:no-repeat;
background-size:cover;
background-position:center;
	IMG {display:none;}*/
  }
  .head_block_1_wrapper .column_3 {
    order: 3;
    right: unset;
    align-self: flex-end;
    padding-right: 21px;
  }
  .head_block_1_wrapper .small_image {
    margin-bottom: 10px;
  }
}
/*end responsive header*/
/*download block*/
.download_1 {
  position: relative;
  padding: 24px;
  padding-top: 0px;
  width: 100%;
  max-width: 938px;
  height: 402px;
  background: rgba(203, 207, 44, 0.9);
  border-radius: 30px;
  margin: 0 auto;
  margin-top: 127px; /*97*/
  /*background-color:orange;*/
  overflow: visible; /*
&::before
{
  content: "";
  position: absolute;
  width: 100%;
  height: 100%;
  top: -50%;
  left: -50%;
  z-index: -1;
  background-image:url('/i/glow_bg_app_store.png');
}*/
}
.download_1 .qr {
  position: absolute;
  bottom: 28px;
  right: 28px;
  z-index: 1;
  pointer-events: none;
  max-width: 219px;
}
.download_1 .glow {
  position: absolute;
  top: -50%; /*70%*/
  left: 0px;
  right: 0px;
  z-index: -2;
}
.download_1 .mobile {
  width: 471px; /*460 545*/
  position: absolute;
  top: -44px; /*-19%*/
  right: 180px;
  z-index: 1;
  transition: 0.5s opacity linear;
  opacity: 0;
  pointer-events: none;
}
.download_1 .button_wrapper {
  margin-left: 13px;
}
.download_1 .button {
  display: block;
  max-width: 256px;
  height: 45px;
  background-color: #202020;
  border-radius: 10px;
  background-position: center;
  background-repeat: no-repeat;
  padding-top: 7px;
  padding-bottom: 7px;
  margin-top: 7px; /*16*/
  cursor: pointer;
  transition: 0.3s background linear;
}
.download_1 .button:hover {
  background-color: #A99C56;
}
.download_1 .button:first-child {
  margin-top: 92px; /*50*/
}
.download_1 .image {
  max-width: 355px;
  margin-left: 13px; /*37*/
  padding-top: 34px;
  width: 100%;
  opacity: 0;
  transition: 0.5s opacity linear;
}
.download_1 .wrapper {
  display: flex;
}

/*responsive download*/
@media all and (max-width: 991px) {
  .download_1 {
    margin-top: 40px; /*47*/
    padding-left: 0px;
    padding-right: 0px;
    max-width: 263px; /*328 255*/
    height: 237px; /*278 235*/
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
  }
  .download_1 .qr {
    display: none;
  }
  .download_1 .image {
    padding-top: 19px;
    max-width: 194px; /*227*/
    margin-left: 19px;
  }
  .download_1 .glow {
    display: none;
    /*max-width:none;
    width:100vw;*/
  }
  .download_1 .button_wrapper {
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    margin: 0 auto;
  }
  .download_1 .button:first-child {
    margin-top: 37px;
  }
  .download_1 .button {
    width: 227px;
    height: 40px;
    background-size: 88px;
    padding: 6px;
  }
  .download_1 .mobile {
    display: none;
  }
}
/*end responsive download*/
/*end of download*/
/*missions*/
.missions {
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding-left: 24px;
  padding-right: 24px;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_2___});
  background-repeat: no-repeat;
  background-size: initial; /*cover*/
  background-position: center 0px; /*top right*/
  overflow: visible;
}
.missions .missions_bg {
  position: absolute;
  left: 0px;
  bottom: -140px; /*-203*/
  max-width: 100%;
}
.missions .missions_bg_bottom {
  position: absolute;
  left: 0px;
  bottom: -30%;
  z-index: -2;
  max-width: 100%;
}
.missions .title {
  font-family: var(--second-family);
  font-weight: 400;
  font-size: 36px;
  line-height: 106%;
  text-align: center;
  color: #040628;
  text-transform: uppercase;
  margin-top: 159px; /*97*/
  width: 100%;
}
.missions .title SPAN {
  font-family: "Atom-Bold";
}
.missions .text {
  font-family: "Atom-Light";
  font-size: 24px;
  line-height: 1.2;
  text-align: center;
  color: #040628;
  margin-top: 32px; /*32*/
  max-width: 659px; /*904*/
  width: 100%;
}
.missions .text B, .missions .text STRONG {
  font-family: "Atom-Bold";
}

.missions_wrapper {
  display: flex;
  align-items: flex-start;
  justify-content: center; /*space-between*/
  max-width: 741px;
  margin-top: 68px;
  width: 100%;
}
.missions_wrapper .one:nth-child(2n) .image_bottom {
  width: 370px;
  max-width: none;
}
.missions_wrapper .one {
  position: relative;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  flex-direction: column;
  flex-shrink: 0;
  border-radius: 30px;
  background: rgba(167, 171, 40, 0.9);
  max-width: 341px;
  width: 100%;
  height: 398px;
}
.missions_wrapper .one:first-child {
  margin-top: 53px;
  margin-right: 59px;
}
.missions_wrapper .one .image {
  opacity: 0;
  transition: 0.5s opacity linear;
}
.missions_wrapper .one .image_top {
  position: absolute;
  top: -46px;
}
.missions_wrapper .one .image_bottom {
  position: absolute;
  bottom: -174px;
}
.missions_wrapper .one .title {
  font-family: var(--second-family);
  font-weight: 400;
  font-size: 36px;
  color: #fbff6c;
  text-transform: uppercase;
  margin-top: 72px;
}
.missions_wrapper .one .text {
  font-family: var(--font3);
  font-weight: 400;
  font-size: 20px;
  line-height: 115%;
  text-align: center;
  color: #ffffff;
  margin-top: 41px; /*39*/
  max-width: 280px; /*904*/
  width: 100%;
}

/*responsive of missions*/
@media all and (max-width: 991px) {
  .missions {
    background-image: none;
  }
  .missions .missions_bg_bottom {
    display: none;
  }
  .missions .one {
    position: relative;
    overflow: visible;
  }
  .missions .one:after {
    content: "";
    position: absolute;
    /*left:calc((100vw - 264px)/2*-1);*/
    bottom: -142px;
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_3___});
    background-repeat: no-repeat;
    background-size: 100%;
    background-position: center 0px;
    width: 100%;
    /*height:219px;*/
    aspect-ratio: 1491/748;
    pointer-events: none;
  }
  .missions .missions_bg {
    bottom: unset;
    top: 309px;
    max-width: 70%;
  }
  .missions .title {
    font-size: 17px;
    line-height: 112%;
    max-width: 207px;
    margin-top: 45px;
  }
  .missions .text {
    font-size: 14px;
    margin-top: 16px;
    max-width: 232px;
  }
  .missions_wrapper {
    margin-top: 57px;
    flex-direction: column;
    align-items: center;
    overflow: visible;
  }
  .missions_wrapper .one {
    margin-top: 151px; /*57*/
    width: 264px;
    height: 294px;
  }
  .missions_wrapper .one:first-child {
    margin-top: 0px;
    margin-right: 0px;
  }
  .missions_wrapper .one:first-child .image_top {
    width: 65px;
    top: -33px;
  }
  .missions_wrapper .one:first-child .image_bottom {
    width: 248px; /*190*/
    bottom: -137px;
  }
  .missions_wrapper .one .image_top {
    width: 72px;
    top: -39px;
  }
  .missions_wrapper .one .text {
    max-width: 196px;
  }
  .missions_wrapper .one .image_bottom {
    max-width: 100% !important;
    width: 268px; /*190*/
    bottom: -136px;
    z-index: 1;
  }
  .missions_wrapper .one .title {
    font-size: 27px;
    margin-top: 52px;
  }
  .missions_wrapper .one .text {
    font-size: 14px;
    line-height: 121%;
    margin-top: 29px;
  }
}
@media all and (max-width: 991px) and (min-width: 625px) {
  .missions_wrapper {
    flex-direction: row;
    gap: 20px;
  }
  .missions_wrapper .one {
    margin-top: 0px;
  }
  .missions_wrapper .one:first-child {
    margin-top: 40px;
  }
}
/*end responsive*/
/*end of missions*/
/*store*/
.store {
  display: flex;
  flex-direction: column;
  align-items: center;
  overflow: visible;
  position: relative;
  /*
  background-image:url('/i/milk 1.png');
  background-position:left -300px;
  background-repeat:no-repeat;
  background-size:100%;*/
}
.store .store_bg {
  position: absolute;
  top: 0px; /*-200*/
  right: 0px;
  width: 100%;
  max-width: 359px;
  z-index: -1;
}
.store .store_title {
  font-family: var(--second-family);
  font-weight: 400;
  font-size: 36px;
  line-height: 106%;
  text-align: center;
  color: #040628;
  text-transform: uppercase;
  margin-top: 237px;
  width: 100%;
}
.store .store_title SPAN {
  font-family: "Atom-Bold";
}
.store .store_subtitle {
  font-family: "Atom-Light";
  font-size: 24px;
  line-height: 1.2;
  text-align: center;
  color: #040628;
  margin-top: 32px; /*32*/
  max-width: 659px; /*904*/
  width: 100%;
}
.store .store_subtitle B, .store .store_subtitle STRONG {
  font-family: "Atom-Bold";
}
.store .wrapper_arrows {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 36px;
  max-width: 820px;
  width: 100%;
}
.store .wrapper_arrows .item {
  font-family: var(--second-family);
  font-size: 36px;
  line-height: 106%;
  text-align: center;
  color: #040628;
}
.store .wrapper_top {
  display: grid;
  justify-content: space-between;
  margin-top: 18px; /*19*/
  max-width: 1136px;
  width: 100%;
  grid-template-columns: 1fr 1fr 1fr;
  gap: 7px;
}
.store .wrapper_top .one {
  position: relative;
  z-index: 1;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  flex-direction: column;
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
  width: 100%;
  border-radius: 30px;
  max-width: 369px;
  height: 196px;
}
.store .wrapper_top .one .image {
  position: absolute;
  top: 70px;
  display: flex;
  justify-content: center;
  align-items: center;
  max-width: 100%;
  pointer-events: none;
}
.store .wrapper_top .one .text {
  font-family: "Atom-Light";
  font-size: 24px;
  line-height: 1.2;
  text-align: center;
  color: #ffffff;
  margin-top: 27px; /*28 32*/
  max-width: 300px; /*283 904*/
  width: 100%;
}
.store .wrapper_top .one .text B, .store .wrapper_top .one .text STRONG {
  font-family: "Atom-Medium";
}
.store .store_wrapper_end {
  background-color: red;
  width: 100%;
  height: 100px;
  grid-column: 3 span;
  clip-path: ellipse(125% 100% at top);
}
.store .store_big_wrapper {
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  background-color: #040628;
  width: 100%;
  padding-bottom: 95px; /*176*/
  padding-top: 100px;
  margin-top: 43px; /*100*/
}
.store .store_big_wrapper:after {
  content: "";
  position: absolute;
  bottom: 0px;
  top: 0px;
  background-color: #CCCF2C;
  width: 100%;
  height: 100px;
  clip-path: ellipse(55% 100% at top);
}
.store .title_count {
  font-family: "Atom-Bold";
  font-size: 24px;
  line-height: 28px;
  text-transform: uppercase;
  text-align: center;
  color: #ffffff;
  margin-top: 72px; /*77*/
  max-width: 401px; /*393*/
  width: 100%;
}
.store .store_cards {
  /*display:flex;
  flex-wrap:wrap;*/
  display: grid;
  grid-auto-flow: dense;
  grid-template-columns: 255px 255px 255px 255px;
  grid-gap: 16px;
  justify-content: center;
  max-width: 1116px;
  width: 100%;
  margin-top: 45px; /*29 36 45*/
  padding-left: 24px;
  padding-right: 24px;
}
.store .store_cards .slider_points {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 22px; /*10*/
  /*
  LI
  {
  width:9px;
  height:9px;
  font-size:20px;
  list-style-type:circle;
  margin-left:3px;
  margin-right:4px;
  cursor:pointer;
  }*/
}
.store .store_cards .slider_points .slider_point {
  width: 8px;
  height: 8px;
  margin-right: 9px; /*10*/
  border-radius: 50%;
  border: 1px solid #ffffff;
  transition: 0.3s all linear;
  cursor: pointer;
  box-sizing: none;
}
.store .store_cards .slider_points .slider_point:last-child {
  margin-right: 0px;
}
.store .store_cards .slider_points .slider_point_active {
  border: 1px solid #FFFFFF;
  background-color: #FFFFFF;
  /*font-size:26px;
  line-height:29px;
  color:#48FFB2;
  list-style-type:disc;*/
}
.store .store_card {
  grid-column: span 1;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  /*margin-right:16px;
  margin-top:16px;*/
  width: 255px;
  height: 440px;
  line-height: normal;
  padding-top: 18px;
  padding-bottom: 18px;
  padding-left: 20px; /*23*/
  padding-right: 20px; /*22*/
  background-repeat: no-repeat;
  background-size: 100%;
  cursor: pointer;
}
.store .store_card:last-child {
  margin-right: 0px;
}
.store .store_card:nth-child(4) {
  margin-right: 0px;
}
.store .store_card .store_card_wrapper_top {
  /*margin-top:22px;*/
}
.store .store_card .store_card_wrapper_top .title {
  font-family: "Atom-Medium";
  font-size: 24px;
  text-transform: uppercase;
  color: #ffffff;
}
.store .store_card .store_card_wrapper_top .title .green {
  color: #48FFB2;
}
.store .store_card .store_card_wrapper_top .subtitle {
  display: flex;
  font-family: "Atom-Medium";
  font-size: 32px;
  line-height: 62%;
  color: #48ffb2;
  margin-top: 25px; /*26*/
  align-items: flex-end; /*center*/
}
.store .store_card .store_card_wrapper_top .subtitle IMG {
  margin-right: 10px; /*11*/
}
.store .store_card .title_bottom {
  font-family: var(--font-family);
  font-size: 20px;
  line-height: 23px;
  color: #ffffff;
  /*margin-bottom:23px;*/
}
.store .store_card .title_bottom STRONG {
  font-weight: 700;
  text-transform: uppercase;
}
.store .store_card .title_bottom_out {
  font-family: "Atom-Medium";
  font-size: 14px; /*15 9*/
  letter-spacing: 0.02em;
  text-transform: uppercase;
  color: #000;
  padding-top: 25px;
}
.store .store_card_big {
  grid-column: span 2;
  width: 526px;
}

/*responsive of store*/
@media all and (max-width: 1115px) {
  .store .store_cards {
    max-width: 845px; /*797*/
    grid-template-columns: 255px 255px 255px;
    grid-auto-flow: dense;
  }
}
@media all and (max-width: 991px) {
  .store .wrapper_arrows {
    display: none;
  }
  .store .wrapper_top {
    grid-template-columns: 1fr;
    gap: 55px; /*46 30*/
  }
  .store .wrapper_top .one {
    max-width: 264px;
    height: 140px;
    justify-self: center;
  }
  .store .wrapper_top .one .text {
    position: relative;
    z-index: 1;
    font-size: 17px;
    margin-top: 20px;
    max-width: 200px;
    text-align: center;
  }
  .store .wrapper_top .one .image {
    top: 50px;
    width: 114px;
  }
  .store .wrapper_top .one:nth-child(2n) .image {
    width: 160px; /*139*/
    /*transform: rotate(-13deg);*/
  }
  .store .wrapper_top .one:nth-child(3n) .image {
    top: 60px;
    width: 123px;
  }
  .store .store_bg {
    position: static;
    margin-top: 112px; /*90 70*/
    align-self: flex-end;
    width: auto;
    max-width: 70%;
  }
  .store .store_title {
    font-size: 17px;
    line-height: 112%;
    max-width: 207px;
    margin-top: 7px; /*45*/
  }
  .store .store_subtitle {
    font-size: 14px;
    margin-top: 16px;
    max-width: 158px;
  }
  .store .wrapper_top {
    flex-direction: column;
    margin-top: 27px; /*36*/
  }
  .store .title_count {
    font-size: 14px;
    line-height: 17px;
    margin-top: 53px; /*48 37*/
    max-width: 234px; /*229*/
    /*order:99;*/
  }
  .store .store_cards {
    margin-top: 24px; /*34 20*/
  }
  .store .store_big_wrapper {
    padding-top: 10px;
    padding-bottom: 37px; /*50*/
  }
  .store .store_big_wrapper:after {
    width: 100%;
    height: 30px;
    clip-path: ellipse(50% 100% at top);
  }
}
@media all and (max-width: 860px) {
  .store .store_cards {
    grid-template-columns: 255px 255px;
    max-width: 574px; /*526*/
  }
}
@media all and (max-width: 991px) and (min-width: 625px) {
  .store .wrapper_top {
    grid-template-columns: 1fr 1fr;
    gap: 50px;
  }
  .store .wrapper_top .one {
    justify-self: center;
  }
  .store .wrapper_top .one:last-child {
    grid-column: 2 span;
  }
}
@media all and (max-width: 600px) {
  .store .store_cards {
    display: flex;
    flex-direction: column;
    align-items: center;
  }
  .store .store_card {
    animation-name: fadeIn;
    animation-iteration-count: 1;
    animation-timing-function: linear;
    animation-duration: 1s;
    animation-fill-mode: forwards;
    margin-right: 0 !important;
  }
  .store .store_card .title_bottom_out {
    font-size: 13px;
    text-align: center;
  }
}
/*end responsive of store*/
/*end of store*/
/*change block*/
.change_wrapper {
  background-color: #040628;
}

.change {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: 0px; /*65*/
  line-height: normal;
  background-color: #CBCF2C;
  clip-path: ellipse(150% 100% at bottom); /*125 80%*/
}
.change .title_change {
  font-family: var(--second-family);
  font-weight: 400;
  font-size: 36px;
  line-height: 106%;
  text-align: center;
  color: #040628;
  text-transform: uppercase;
  margin-top: 79px; /*65*/
  width: 100%;
}
.change .title_change SPAN {
  font-family: "Atom-Bold";
}
.change .text_change {
  font-family: "Atom-Light";
  font-size: 24px;
  line-height: 1.2;
  text-align: center;
  color: #040628;
  margin-top: 32px; /*32*/
  max-width: 634px; /*904*/
  width: 100%;
}

.change_button {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: row;
  gap: 10px;
  border-radius: 40px;
  padding: 22px 29px 19px 29px;
  width: 361px;
  height: 79px;
  background: linear-gradient(184deg, #040628 0%, #282e95 100%);
  margin-top: 44px;
  font-family: "Atom-Medium";
  font-size: 21px;
  color: #ffffff;
  transition: 0.3s all linear;
  filter: brightness(1);
}

.change_button:hover {
  filter: brightness(1.2);
}

@media all and (max-width: 991px) {
  .change .title_change {
    font-size: 17px;
    line-height: 112%;
    max-width: 207px;
    margin-top: 42px; /*45*/
  }
  .change .text_change {
    font-size: 14px;
    margin-top: 16px;
    max-width: 189px; /*232*/
  }
}
.change_big_wrapper {
  display: flex;
  width: 100%;
}
.change_big_wrapper .change_big {
  display: flex;
  justify-content: flex-end;
  width: 100%;
}
.change_big_wrapper .change_big_img {
  position: relative;
  top: -150px;
  max-width: min(728px, 100%); /*min(992px,100%)*/
  height: max-content;
  z-index: -1;
  aspect-ratio: 728/862;
}

.change_wrapper1 {
  display: flex;
  margin-top: 65px; /*58*/
  margin-bottom: 86px;
  width: 100%;
  flex-direction: column;
}
.change_wrapper1 .column1 {
  display: flex;
  flex-direction: column;
  padding-left: 30px;
}
.change_wrapper1 .column1 .top_symbol {
  display: flex;
  align-items: flex-start;
  justify-content: center;
}
.change_wrapper1 .column1 .top_symbol .word {
  font-family: var(--second-family);
  font-size: 96px;
  line-height: 86px;
  text-align: center;
  color: #ffffff;
}
.change_wrapper1 .column1 .top_symbol .word2 {
  font-family: var(--second-family);
  font-size: 15px;
  text-align: center;
  color: #ffffff;
  margin-left: 3px;
}
.change_wrapper1 .column1 .text {
  font-family: var(--font-family);
  font-size: 24px;
  text-align: center;
  color: #040628;
  margin-top: 10px; /*29*/
}
.change_wrapper1 .column1 .text .bold {
  font-family: "Atom-Bold";
}
.change_wrapper1 .column2 {
  display: flex;
  justify-content: space-between;
  flex-direction: column;
  align-items: center;
  margin-top: 70px;
}
.change_wrapper1 .column2 .image {
  width: 89px;
  filter: brightness(1);
  transition: 0.3s all linear;
}
.change_wrapper1 .column2 .image:HOVER {
  filter: brightness(1.1);
}
.change_wrapper1 .column2 .text {
  font-family: var(--font-family);
  font-size: 24px;
  text-align: center;
  color: #040628;
  margin-top: 22px; /*23*/
}
.change_wrapper1 .column2 .text .bold {
  font-family: "Atom-Bold";
}
.change_wrapper1 .column2 .button {
  font-family: "fs_eliot";
  font-size: 24px;
  font-weight: 400;
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 40px;
  padding: 25px 32px 21px 32px;
  width: 405px; /*100%*/
  max-width: 405px;
  height: 77px; /*79*/
  background: #a7ab28;
  cursor: pointer;
  transition: 0.3s all linear;
  margin-top: 49px;
}
.change_wrapper1 .column2 .button:HOVER {
  background: #202020;
}

.change_qr {
  display: block;
  width: 269px;
  margin: 0 auto;
  /*margin-top:122px;*/
  transition: 1s transform linear;
}
.change_qr:hover {
  transform: scale(1.5);
}

.change_download DIV:first-child {
  display: flex;
  flex-direction: column;
}
.change_download .slider_points {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 43px; /*50 55*/
  margin-bottom: 17px; /*22*/
}
.change_download .slider_points .slider_point {
  width: 8px;
  height: 8px;
  margin-right: 9px; /*10*/
  border-radius: 50%;
  border: 1px solid #040628;
  transition: 0.3s all linear;
  cursor: pointer;
  box-sizing: none;
}
.change_download .slider_points .slider_point:last-child {
  margin-right: 0px;
}
.change_download .slider_points .slider_point_active {
  border: 1px solid #040628;
  background-color: #040628;
}
.change_download .change_download_text {
  font-family: "Atom-Bold";
  font-size: 24px;
  text-transform: uppercase;
  text-align: center;
  color: #040628;
  animation-name: fadeIn;
  animation-iteration-count: 1;
  animation-timing-function: linear;
  animation-duration: 0.5s;
  animation-fill-mode: forwards;
  margin-right: 0 !important;
  order: 99;
}
.change_download .change_download_text span {
  color: #040628;
}

.change_play {
  font-family: var(--second-family);
  font-size: 60px;
  line-height: 100%;
  color: #040628;
  margin-top: 49px; /*75*/
  text-align: center;
}

.change_button_wrapper {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 40px;
  margin-top: 36px; /*52*/
}
.change_button_wrapper A {
  display: block;
  width: 380px;
  max-width: 380px;
  height: 67px;
  background-color: #202020;
  border-radius: 10px;
  background-position: center;
  background-repeat: no-repeat;
  padding-top: 7px;
  padding-bottom: 7px;
  cursor: pointer;
  transition: 0.3s background linear;
}
.change_button_wrapper A:hover {
  background-color: #A99C56;
}

@media all and (min-width: 1922px) {
  .change_wrapper1 {
    align-items: flex-end;
    padding-right: 50px;
  }
  .change_big_wrapper .change_big {
    /*max-width:992px;*/
    justify-content: flex-start;
    padding-left: 50px;
  }
  .change_big_wrapper .change_big_img {
    max-width: min(992px, 100%);
    aspect-ratio: 992/862;
  }
}
@media all and (max-width: 991px) {
  .change_download {
    margin-top: 20px; /*20*/
  }
  .change_big_wrapper {
    flex-direction: column;
  }
  .change_big_wrapper .change_big_img {
    position: relative; /*static*/
    top: -50px;
  }
  .change {
    /*margin-top:51px;*/
    clip-path: ellipse(250% 100% at bottom); /*200*/
  }
  .change .title_change {
    font-size: 17px; /*20*/
    line-height: 21px;
    max-width: unset; /*140*/
  }
  .change_wrapper1 {
    flex-direction: column;
    margin-top: 41px; /*44*/
    margin-bottom: 0px;
  }
  .change_wrapper1 .column1 .top_symbol .word {
    font-size: 54px;
    line-height: 58px;
  }
  .change_wrapper1 .column1 .top_symbol .word2 {
    font-size: 11px;
  }
  .change_wrapper1 .column1 .text {
    font-size: 14px;
    line-height: 17px; /*16*/
    margin-top: 1px; /*7 9*/
  }
  .change_wrapper1 .column2 {
    margin-top: 37px; /*39*/
  }
  .change_wrapper1 .column1 .top_symbol {
    justify-content: center;
    margin-left: 44px;
  }
  .change_wrapper1 .column2 .text {
    font-size: 14px;
    margin-top: 12px;
  }
  .change_wrapper1 .column2 .button {
    border-radius: 21px;
    padding: 13px 17px 11px 17px;
    width: 261px;
    height: 49px;
    gap: 5px;
    font-size: 15px;
    font-weight: 700px;
    margin-top: 24px;
  }
  .change_wrapper1 .column2 .image {
    width: 56px;
  }
  .change_button {
    border-radius: 25px;
    padding: 15px 20px 13px 20px;
    width: 261px;
    height: 49px;
    font-size: 15px;
    margin-top: 20px;
  }
  .change_button .image {
    width: 20px;
  }
  .change_qr {
    display: none;
  }
  .change_download .slider_points {
    margin-bottom: 11px;
    margin-top: 24px; /*62*/
  }
  .change_download .change_download_text {
    font-size: 14px;
  }
  .change_play {
    font-size: 32px;
    margin-top: 34px; /*13*/
    max-width: 183px;
  }
  .change_button_wrapper {
    grid-template-columns: 1fr;
    gap: 7px;
    margin-top: 16px; /*17*/
  }
  .change_button_wrapper A {
    width: 227px;
    height: 40px;
    background-size: 100px;
  }
}
/*end of change block*/
/*footer*/
/*
.footer:after
{
position:absolute;
bottom:0px;
content:'';
width:100%;
height:534px;
background: linear-gradient(0deg, #fdff8a  0%, #cccf2c 100%);
z-index:-1;
pointer-events:none;
}*/
.footer {
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: 46px;
  background: linear-gradient(0deg, #fdff8a 0%, #cccf2c 100%);
}
.footer .copy {
  font-family: var(--font-family);
  font-size: 14px;
  line-height: 150%;
  text-align: center;
  color: #03062a;
  margin-top: 38px;
  padding-bottom: 16px; /*32 30*/
}
.footer .copy2 {
  font-family: var(--font-family);
  font-size: 14px;
  line-height: 150%;
  text-align: center;
  color: #03062a;
  padding-bottom: 34px; /*32 30*/
}
.footer .footer_title {
  font-family: var(--second-family);
  font-size: 36px;
  line-height: 139%;
  text-align: center;
  color: #000000;
  margin-top: 73px;
  max-width: 765px;
}
.footer .footer_title SPAN {
  color: #ffffff;
}

.footer_social {
  display: flex;
  justify-content: center;
  margin-top: 41px; /*86 84*/
}
.footer_social A {
  /*&:hover IMG {filter: drop-shadow(10px 10px 10px #A99C56) invert(0%);}
  IMG {transition:0.3s all linear; filter: drop-shadow(0px 0px 0px transparent) invert(0%);}*/
  margin-right: 28px;
  width: 31px;
}
.footer_social A:last-child {
  margin-right: 0px;
}
.footer_social A:hover IMG {
  filter: invert(10%);
}
.footer_social A IMG {
  transition: 0.3s all linear;
  filter: invert(0%);
}

/*responsive*/
@media all and (max-width: 991px) {
  .footer {
    margin-top: 20px;
  }
  .footer_social {
    margin-top: 21px;
  }
  .footer_social A {
    width: 31px; /*31*/
    margin-right: 17px; /*41*/
  }
  .footer .copy {
    font-size: 10px;
    line-height: 15px;
    padding-bottom: 18px; /*20*/
    margin-top: 65px; /*47 46*/
  }
  .footer .copy2 {
    font-size: 12px;
    line-height: 15px;
    padding-bottom: 20px; /*18 20*/
  }
}
/*end of responsive*/
/*end of footer*/`, "",{"version":3,"sources":["webpack://./src/scss_base/_reset.scss","webpack://./src/App.scss","webpack://./src/variables.scss"],"names":[],"mappings":"AAAA,YAAA;AACA;;;EAGE,sBAAA;EACD,wBAAA;EACA,oBAAA;EACA,oBAAA;EACA,mBAAA;EACA,eAAA;EACA,cAAA;EACA,UAAA;EACA,UAAA;EACA,SAAA;ACCD;;ADGA;;EAEE,UAAA;ACAF;;ADIA;;;;;;;;;;;;;;EAcE,SAAA;ACDF;;ADGA;EAEA,kBAAA;EACA,oBAAA;EACA,oBAAA;EACA,SAAA;EACA,UAAA;ACDA;;ADKA;EACE,iBAAA;EACA,uBAAA;EACA,6BAAA;EACA,gBAAA;ACFF;;ADMA;;EAEE,gBAAA;ACHF;;ADOA;EACE,8BAAA;ACJF;;ADQA;EACE,eAAA;EACA,cAAA;ACLF;;ADSA;EACE,eAAA;ACNF;;ADUA;;;;EAIE,aAAA;ACPF;;ADSA;EAEA,aAAA;EACA,qBAAA;ACPA;;ADSA;EAEA,aAAA;ACPA;;ADSA,gBAAA;AE7FA,SAAA;AAEA,gBAAA;ADFA;EACE,aAAA;AA0FF;;AAxFA;EACE,yBAAA;EACA,4BAAA;EACA,8BAAA;EACA,uBAAA;AA2FF;;AAzFA;EACI;IACI,UAAA;EA4FN;EA1FE;IACI,UAAA;EA4FN;AACF;AA1FA;EACI;IACJ,qBAAA;EA4FE;EA1FC;IACH,wBAAA;EA4FE;EA1FE;IACJ,qBAAA;EA4FE;AACF;AA1FA;EACI;IACJ,qBAAA;EA4FE;EA1FC;IACH,wBAAA;EA4FE;EA1FE;IACJ,qBAAA;EA4FE;AACF;AA1FA;EACI;IACJ,qBAAA;EA4FE;EA1FC;IACH,wBAAA;EA4FE;EA1FE;IACJ,qBAAA;EA4FE;AACF;AA1FA;EACI;IACJ,qBAAA;EA4FE;EA1FC;IACH,wBAAA;EA4FE;EA1FE;IACJ,qBAAA;EA4FE;AACF;AA1FA;EAEA,yBAAA,EAAA,UAAA;EACA,cAAA;EACA;;;2BAAA;AA8FA;;AAzFA;EAEA,qBAAA;AA2FA;;AAzFA;EAEA,gBAAA;AA2FA;;AAzFA;EAEA,wBAAA;AA2FA;;AAzFA;EAEA,kBAAA;EACA,+CAAA;EACA,4BAAA;EACA,sBAAA,EAAA;iDAAA;EAEA,+DAAA;EACA,4FAAA;EACA,yDAAA;EACA,2BAAA,EAAA,oBAAA;EACA,iBAAA;AA2FA;;AAzFA;EAEA,kBAAA;EACA,QAAA;EACA,SAAA;EACA,0FAAA,EAAA,4FAAA;EACA,qBAAA;EACA,WAAA;EACA,WAAA;AA2FA;;AAzFA;EAEA,aAAA;EACA,sBAAA;EACA,8BAAA;EACA,mBAAA;EACA,kBAAA;EACA,kDAAA;EACA,4BAAA;EACA,2CAAA;EACA,iCAAA,EAAA,UAAA;AA2FA;AA1FC;EAED,iCAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;AA2FA;AAzFC;EAED,WAAA;EACA,iBAAA;EACA,gBAAA;AA0FA;;AAvFA;EAEA,kBAAA;EACA,UAAA,EAAA,MAAA;EACA,qBAAA;EACA,aAAA;EACA,uBAAA;EACA,qBAAA;AAyFA;AAxFC;EAED,aAAA;EACA,qBAAA;EACA,mBAAA;AAyFA;AAxFE;EAEF,yBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;AAyFA;AAvFE;EAEF,gBAAA;EACA,YAAA;AAwFA;AArFC;EAEA,kBAAA;EACA,mBAAA,EAAA,YAAA;EACA,cAAA;AAsFD;AArFC;EAAK,kBAAA;AAwFN;AAtFC;EAEA,qCAAA,EAAA,uBAAA;EACD,qBAAA;AAuFA;AArFC;EAEA,kBAAA;EACA,oBAAA,EAAA,YAAA;EACA,cAAA;AAsFD;AArFC;EAAQ,iBAAA;AAwFT;AAvFC;EAAK,gBAAA;AA0FN;;AAtFA;EAEA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,UAAA;AAwFA;AAvFC;EAED,yBAAA;EACA,eAAA;EACA,iBAAA;EACA,kBAAA;EACA,cAAA;EACA,gBAAA;EACA,kBAAA;EACA,mBAAA;AAwFA;AAvFE;EAAM,wBAAA;AA0FR;;AAtFA,oBAAA;AACA;EAGA;IAEA,kBAAA;IACA,gBAAA;EAsFE;EApFF;IAOA,eAAA,EAAA,KAAA;IACA,iBAAA;IACA,cAAA;IACA,kBAAA;IACA,iBAAA;IACA,mBAAA;EAgFE;EA1FF;IAEA,kBAAA;IACA,kBAAA;EA2FE;EAlFF;IAEA,QAAA;IACA,gBAAA,EAAA,KAAA;EAmFE;EAjFF;IAEA,aAAA;EAkFE;AACF;AA/EA;EAGA;IAEA,eAAA;IACA,iBAAA;IACA,cAAA;IACA,iBAAA;IACA,iBAAA;IACA,kBAAA;EA8EE;EA5EF;IAEA,UAAA;EA6EE;EA3EF;IAEA,WAAA;EA4EE;EA1EF;IAEA,gBAAA;IACA,kBAAA;EA2EE;EAzEF;IAEA,iBAAA;EA0EE;EAxEF;IAEA,gBAAA;IACA,gBAAA;EAyEE;EAvEF;IAEA,eAAA;IACA,iBAAA;IACA,cAAA;IACA,kBAAA;IACA,mBAAA;EAwEE;AACF;AApEA;EAEA;IAEA,gBAAA;EAoEE;EAlEF;IAEA,sBAAA;IACA,mBAAA;EAmEE;EAhEF;IAEA,QAAA;IACA,WAAA;IACA,sBAAA;IACA,kBAAA;EAiEE;EA/DF;IAEA,QAAA,EAAA;;;;;;;qBAAA;EAuEE;EA9DF;IAEA,QAAA;IACA,YAAA;IACA,oBAAA;IACA,mBAAA;EA+DE;EA7DF;IAEA,mBAAA;EA8DE;AACF;AA3DA,wBAAA;AACA,iBAAA;AACA;EAEA,kBAAA;EACA,aAAA;EACA,gBAAA;EACA,WAAA;EACA,gBAAA;EACA,aAAA;EACA,mCAAA;EACA,mBAAA;EACA,cAAA;EACA,iBAAA,EAAA,KAAA;EACA,2BAAA;EACA,iBAAA,EAAA;;;;;;;;;;;EAAA;AAuEA;AA3DC;EAED,kBAAA;EACA,YAAA;EACA,WAAA;EACA,UAAA;EACA,oBAAA;EACA,gBAAA;AA4DA;AA1DC;EAED,kBAAA;EACA,SAAA,EAAA,MAAA;EACA,SAAA;EACA,UAAA;EACA,WAAA;AA2DA;AAzDC;EAED,YAAA,EAAA,UAAA;EACA,kBAAA;EACA,UAAA,EAAA,OAAA;EACA,YAAA;EACA,UAAA;EACA,+BAAA;EACA,UAAA;EACA,oBAAA;AA0DA;AAxDC;EAED,iBAAA;AAyDA;AAvDC;EAED,cAAA;EACA,gBAAA;EACA,YAAA;EACA,yBAAA;EACA,mBAAA;EACA,2BAAA;EACA,4BAAA;EACA,gBAAA;EACA,mBAAA;EACA,eAAA,EAAA,KAAA;EACA,eAAA;EACA,kCAAA;AAwDA;AAtDC;EAED,yBAAA;AAuDA;AArDC;EAED,gBAAA,EAAA,KAAA;AAsDA;AApDE;EAEF,gBAAA;EACA,iBAAA,EAAA,KAAA;EACA,iBAAA;EACA,WAAA;EACA,UAAA;EACA,+BAAA;AAqDA;AAnDC;EAED,aAAA;AAoDA;;AAjDA,sBAAA;AACA;EAGA;IAEA,gBAAA,EAAA,KAAA;IACA,iBAAA;IACA,kBAAA;IACA,gBAAA,EAAA,UAAA;IACA,aAAA,EAAA,UAAA;IACA,yDAAA;EAiDE;EA/CF;IAEA,aAAA;EAgDE;EA9CF;IAEA,iBAAA;IACA,gBAAA,EAAA,MAAA;IACA,iBAAA;EA+CE;EA7CF;IAEA,aAAA;IACA;iBAAA;EA+CE;EA5CF;IAEA,aAAA;IACA,uBAAA;IACA,mBAAA;IACA,sBAAA;IACA,cAAA;EA6CE;EA3CF;IAEA,gBAAA;EA4CE;EA1CF;IAEA,YAAA;IACA,YAAA;IACA,qBAAA;IACA,YAAA;EA2CE;EAzCF;IAEA,aAAA;EA0CE;AACF;AAvCA,0BAAA;AACA,kBAAA;AACA,WAAA;AACA;EAEA,kBAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,kBAAA;EACA,mBAAA;EACA,yDAAA;EACA,4BAAA;EACA,wBAAA,EAAA,QAAA;EACA,+BAAA,EAAA,YAAA;EACA,iBAAA;AAwCA;AAvCC;EAED,kBAAA;EACA,SAAA;EACA,cAAA,EAAA,OAAA;EACA,eAAA;AAwCA;AAtCA;EAEA,kBAAA;EACA,SAAA;EACA,YAAA;EACA,WAAA;EACA,eAAA;AAuCA;AArCC;EAED,iCAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,kBAAA;EACA,cAAA;EACA,yBAAA;EACA,iBAAA,EAAA,KAAA;EACA,WAAA;AAsCA;AArCC;EAAM,wBAAA;AAwCP;AAtCC;EAED,yBAAA;EACA,eAAA;EACA,gBAAA;EACA,kBAAA;EACA,cAAA;EACA,gBAAA,EAAA,KAAA;EACA,gBAAA,EAAA,MAAA;EACA,WAAA;AAuCA;AAtCC;EAAW,wBAAA;AAyCZ;;AAtCA;EAEA,aAAA;EACA,uBAAA;EACA,uBAAA,EAAA,gBAAA;EACA,gBAAA;EACA,gBAAA;EACA,WAAA;AAwCA;AAvCC;EAED,YAAA;EACA,eAAA;AAwCA;AAtCC;EAED,kBAAA;EACA,aAAA;EACA,2BAAA;EACA,mBAAA;EACA,sBAAA;EACA,cAAA;EACA,mBAAA;EACA,mCAAA;EACA,gBAAA;EACA,WAAA;EACA,aAAA;AAuCA;AAtCA;EAAe,gBAAA;EAAiB,kBAAA;AA0ChC;AAzCE;EAEF,UAAA;EACA,+BAAA;AA0CA;AAxCE;EAEF,kBAAA;EACA,UAAA;AAyCA;AAvCE;EAEF,kBAAA;EACA,cAAA;AAwCA;AAtCE;EAEF,iCAAA;EACA,gBAAA;EACA,eAAA;EACA,cAAA;EACA,yBAAA;EACA,gBAAA;AAuCA;AArCE;EAEF,yBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,kBAAA;EACA,cAAA;EACA,gBAAA,EAAA,KAAA;EACA,gBAAA,EAAA,MAAA;EACA,WAAA;AAsCA;;AAlCA,yBAAA;AACA;EAGA;IAEA,sBAAA;EAkCE;EAhCF;IAEA,aAAA;EAiCE;EA/BF;IAEA,kBAAA;IACA,iBAAA;EAgCE;EA9BF;IAEA,WAAA;IACA,kBAAA;IACA,mCAAA;IACA,cAAA;IACA,yDAAA;IACA,4BAAA;IACA,qBAAA;IACA,+BAAA;IACA,WAAA;IACA,gBAAA;IACA,sBAAA;IACA,oBAAA;EA+BE;EA5BF;IAEA,aAAA;IACA,UAAA;IACA,cAAA;EA6BE;EA3BF;IAEA,eAAA;IACA,iBAAA;IACA,gBAAA;IACA,gBAAA;EA4BE;EA1BF;IAEA,eAAA;IACA,gBAAA;IACA,gBAAA;EA2BE;EAzBF;IAEA,gBAAA;IACA,sBAAA;IACA,mBAAA;IACA,iBAAA;EA0BE;EAzBD;IAQD,iBAAA,EAAA,KAAA;IACA,YAAA;IACA,aAAA;EAoBE;EA5BA;IAEF,eAAA;IAAgB,iBAAA;EA8Bd;EA7BF;IAAY,WAAA;IAAY,UAAA;EAiCtB;EAhCF;IAAe,YAAA,EAAA,MAAA;IAAoB,cAAA;EAoCjC;EA/BD;IAAY,WAAA;IAAY,UAAA;EAmCvB;EAlCD;IAAO,gBAAA;EAqCN;EApCI;IAAe,0BAAA;IAA0B,YAAA,EAAA,MAAA;IAAoB,cAAA;IAAe,UAAA;EA0ChF;EAvCF;IAEA,eAAA;IACA,gBAAA;EAwCE;EAtCF;IAEA,eAAA;IACA,iBAAA;IACA,gBAAA;EAuCE;AACF;AApCA;EAGA;IAEA,mBAAA;IACA,SAAA;EAmCE;EAlCD;IAGD,eAAA;EAkCE;EAnCF;IAAe,gBAAA;EAsCb;AACF;AAjCA,iBAAA;AACA,kBAAA;AACA,QAAA;AACA;EAEA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,iBAAA;EACA,kBAAA;EACA;;;;wBAAA;AAsCA;AAjCC;EAED,kBAAA;EACA,QAAA,EAAA,OAAA;EACA,UAAA;EACA,WAAA;EACA,gBAAA;EACA,WAAA;AAkCA;AAhCC;EAED,iCAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,kBAAA;EACA,cAAA;EACA,yBAAA;EACA,iBAAA;EACA,WAAA;AAiCA;AAhCC;EAAM,wBAAA;AAmCP;AAjCC;EAED,yBAAA;EACA,eAAA;EACA,gBAAA;EACA,kBAAA;EACA,cAAA;EACA,gBAAA,EAAA,KAAA;EACA,gBAAA,EAAA,MAAA;EACA,WAAA;AAkCA;AAjCC;EAAW,wBAAA;AAoCZ;AAlCC;EAED,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,gBAAA;EACA,gBAAA;EACA,WAAA;AAmCA;AAlCE;EAEF,iCAAA;EACA,eAAA;EACA,iBAAA;EACA,kBAAA;EACA,cAAA;AAmCA;AAhCC;EAED,aAAA;EACA,8BAAA;EACA,gBAAA,EAAA,KAAA;EACA,iBAAA;EACA,WAAA;EACA,kCAAA;EACA,QAAA;AAiCA;AAhCE;EAEF,kBAAA;EACA,UAAA;EACA,aAAA;EACA,2BAAA;EACA,mBAAA;EACA,sBAAA;EACA,2BAAA;EACA,4BAAA;EACA,sBAAA;EACA,WAAA;EACA,mBAAA;EACA,gBAAA;EACA,aAAA;AAiCA;AAhCA;EAEA,kBAAA;EACA,SAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,eAAA;EACA,oBAAA;AAiCA;AA9BA;EAEA,yBAAA;EACA,eAAA;EACA,gBAAA;EACA,kBAAA;EACA,cAAA;EACA,gBAAA,EAAA,QAAA;EACA,gBAAA,EAAA,UAAA;EACA,WAAA;AA+BA;AA9BC;EAAW,0BAAA;AAiCZ;AA7BA;EAEA,qBAAA;EACA,WAAA;EACA,aAAA;EACA,mBAAA;EACA,oCAAA;AA8BA;AA5BA;EAEA,kBAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,yBAAA;EACA,WAAA;EACA,oBAAA,EAAA,MAAA;EACA,kBAAA;EACA,gBAAA,EAAA,MAAA;AA6BA;AA5BC;EAED,WAAA;EACA,kBAAA;EACA,WAAA;EACA,QAAA;EACA,yBAAA;EACA,WAAA;EACA,aAAA;EACA,mCAAA;AA6BA;AA1BC;EAGD,wBAAA;EACA,eAAA;EACA,iBAAA;EACA,yBAAA;EACA,kBAAA;EACA,cAAA;EACA,gBAAA,EAAA,KAAA;EACA,gBAAA,EAAA,MAAA;EACA,WAAA;AA0BA;AAxBC;EAED;kBAAA;EAEA,aAAA;EACA,qBAAA;EACA,8CAAA;EACA,cAAA;EACA,uBAAA;EACA,iBAAA;EACA,WAAA;EACA,gBAAA,EAAA,WAAA;EACA,kBAAA;EACA,mBAAA;AAyBA;AAxBE;EAEF,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,gBAAA,EAAA,KAAA;EACA;;;;;;;;;;IAAA;AAmCA;AAxBA;EAEA,UAAA;EACA,WAAA;EACA,iBAAA,EAAA,KAAA;EACA,kBAAA;EACA,yBAAA;EACA,2BAAA;EACA,eAAA;EACA,gBAAA;AAyBA;AAvBA;EAEA,iBAAA;AAwBA;AAtBA;EAEA,yBAAA;EACA,yBAAA;EACA;;;wBAAA;AA0BA;AAnBC;EAED,mBAAA;EACA,aAAA;EACA,sBAAA;EACA,8BAAA;EACA;mBAAA;EAEA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,iBAAA;EACA,oBAAA;EACA,kBAAA,EAAA,KAAA;EACA,mBAAA,EAAA,KAAA;EACA,4BAAA;EACA,qBAAA;EACA,eAAA;AAoBA;AAnBA;EAAc,iBAAA;AAsBd;AArBA;EAAgB,iBAAA;AAwBhB;AAvBC;EAED,mBAAA;AAwBA;AAvBA;EAGA,0BAAA;EACA,eAAA;EACA,yBAAA;EACA,cAAA;AAuBA;AA3BA;EAAQ,cAAA;AA8BR;AAxBA;EAEA,aAAA;EACA,0BAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;EACA,gBAAA,EAAA,KAAA;EACA,qBAAA,EAAA,SAAA;AAyBA;AAxBC;EAAK,kBAAA,EAAA,KAAA;AA2BN;AAvBE;EAEF,+BAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;EACA,sBAAA;AAwBA;AAvBA;EAEA,gBAAA;EACA,yBAAA;AAwBA;AArBE;EAEF,0BAAA;EACA,eAAA,EAAA,OAAA;EACA,sBAAA;EACA,yBAAA;EACA,WAAA;EACA,iBAAA;AAsBA;AAnBC;EAED,mBAAA;EACA,YAAA;AAoBA;;AAjBA,sBAAA;AAEA;EAEA;IAEA,gBAAA,EAAA,MAAA;IACA,wCAAA;IACA,qBAAA;EAiBE;AACF;AAbA;EAEA;IAEA,aAAA;EAaE;EAXF;IAEA,0BAAA;IACA,SAAA,EAAA,QAAA;EAYE;EAXD;IAED,gBAAA;IACA,aAAA;IACA,oBAAA;EAYE;EAXA;IAEF,kBAAA;IACA,UAAA;IACA,eAAA;IACA,gBAAA;IACA,gBAAA;IACA,kBAAA;EAYE;EAVA;IAEF,SAAA;IACA,YAAA;EAWE;EARD;IAED,YAAA,EAAA,MAAA;IACA,6BAAA;EASE;EAPD;IAED,SAAA;IACA,YAAA;EAQE;EALF;IAEA,gBAAA;IACA,iBAAA,EAAA,QAAA;IACA,oBAAA;IACA,WAAA;IACA,cAAA;EAME;EAJF;IAEA,eAAA;IACA,iBAAA;IACA,gBAAA;IACA,eAAA,EAAA,KAAA;EAKE;EAHF;IAEA,eAAA;IACA,gBAAA;IACA,gBAAA;EAIE;EAFF;IAEA,sBAAA;IACA,gBAAA,EAAA,KAAA;EAGE;EADF;IAEA,eAAA;IACA,iBAAA;IACA,gBAAA,EAAA,QAAA;IACA,gBAAA,EAAA,MAAA;IACA,YAAA;EAEE;EAAF;IAEA,gBAAA,EAAA,QAAA;EACE;EACF;IAEA,iBAAA;IACA,oBAAA,EAAA,KAAA;EAAE;EAEF;IAEA,WAAA;IACA,YAAA;IACA,mCAAA;EADE;AACF;AAKA;EAGA;IAEA,kCAAA;IACA,gBAAA,EAAA,MAAA;EANE;AACF;AASA;EAGA;IAEA,8BAAA;IACA,SAAA;EAVE;EAYF;IAMA,oBAAA;EAfE;EAWF;IAEA,mBAAA;EAVE;AACF;AAgBA;EAGA;IAEA,aAAA;IACA,sBAAA;IACA,mBAAA;EAjBE;EAmBF;IAEA,sBAAA;IACA,4BAAA;IACA,iCAAA;IACA,sBAAA;IACA,6BAAA;IACA,0BAAA;EAlBE;EAoBF;IAEA,eAAA;IACA,kBAAA;EAnBE;AACF;AAsBA,0BAAA;AACA,eAAA;AACA,eAAA;AACA;EAEA,yBAAA;AArBA;;AAuBA;EAEA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,eAAA,EAAA,KAAA;EACA,mBAAA;EACA,yBAAA;EACA,uCAAA,EAAA,UAAA;AArBA;AAuBC;EAED,iCAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,kBAAA;EACA,cAAA;EACA,yBAAA;EACA,gBAAA,EAAA,KAAA;EACA,WAAA;AAtBA;AAuBC;EAAM,wBAAA;AApBP;AAsBC;EAED,yBAAA;EACA,eAAA;EACA,gBAAA;EACA,kBAAA;EACA,cAAA;EACA,gBAAA,EAAA,KAAA;EACA,gBAAA,EAAA,MAAA;EACA,WAAA;AArBA;;AAyBA;EAEA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,mBAAA;EACA,SAAA;EACA,mBAAA;EACA,4BAAA;EACA,YAAA;EACA,YAAA;EACA,6DAAA;EACA,gBAAA;EACA,0BAAA;EACA,eAAA;EACA,cAAA;EACA,2BAAA;EACA,qBAAA;AAvBA;;AAyBA;EAEA,uBAAA;AAvBA;;AA2BA;EAGA;IAEA,eAAA;IACA,iBAAA;IACA,gBAAA;IACA,gBAAA,EAAA,KAAA;EA3BE;EA6BF;IAEA,eAAA;IACA,gBAAA;IACA,gBAAA,EAAA,MAAA;EA5BE;AACF;AAgCA;EAEA,aAAA;EACA,WAAA;AA/BA;AAgCC;EAED,aAAA;EACA,yBAAA;EACA,WAAA;AA/BA;AAiCE;EAEF,kBAAA;EACA,WAAA;EACA,2BAAA,EAAA,kBAAA;EACA,mBAAA;EACA,WAAA;EACA,qBAAA;AAhCA;;AAmCA;EAEA,aAAA;EACA,gBAAA,EAAA,KAAA;EACA,mBAAA;EACA,WAAA;EACA,sBAAA;AAjCA;AAkCC;EAED,aAAA;EACA,sBAAA;EACA,kBAAA;AAjCA;AAkCC;EAED,aAAA;EACA,uBAAA;EACA,uBAAA;AAjCA;AAkCE;EAEF,iCAAA;EACA,eAAA;EACA,iBAAA;EACA,kBAAA;EACA,cAAA;AAjCA;AAmCE;EAEF,iCAAA;EACA,eAAA;EACA,kBAAA;EACA,cAAA;EACA,gBAAA;AAlCA;AAqCA;EAEA,+BAAA;EACA,eAAA;EACA,kBAAA;EACA,cAAA;EACA,gBAAA,EAAA,KAAA;AApCA;AAqCC;EAAO,wBAAA;AAlCR;AAqCE;EAEF,aAAA;EACA,8BAAA;EACA,sBAAA;EACA,mBAAA;EACA,gBAAA;AApCA;AAqCC;EAED,WAAA;EACA,qBAAA;EACA,2BAAA;AApCA;AAsCA;EAEA,uBAAA;AArCA;AAuCC;EAED,+BAAA;EACA,eAAA;EACA,kBAAA;EACA,cAAA;EACA,gBAAA,EAAA,KAAA;AAtCA;AAuCC;EAAO,wBAAA;AApCR;AAsCC;EAED,uBAAA;EACA,eAAA;EACA,gBAAA;EACA,WAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,mBAAA;EACA,4BAAA;EACA,YAAA,EAAA,OAAA;EACA,gBAAA;EACA,YAAA,EAAA,KAAA;EACA,mBAAA;EACA,eAAA;EACA,2BAAA;EACA,gBAAA;AArCA;AAuCC;EAED,mBAAA;AAtCA;;AA0CA;EAGA,cAAA;EACA,YAAA;EACA,cAAA;EACA,oBAAA;EACA,+BAAA;AAzCA;AAoCA;EAAQ,qBAAA;AAjCR;;AA0CA;EAEA,aAAA;EACA,sBAAA;AAxCA;AA0CE;EAEF,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,gBAAA,EAAA,QAAA;EACA,mBAAA,EAAA,KAAA;AAzCA;AA0CA;EAEA,UAAA;EACA,WAAA;EACA,iBAAA,EAAA,KAAA;EACA,kBAAA;EACA,yBAAA;EACA,2BAAA;EACA,eAAA;EACA,gBAAA;AAzCA;AA2CA;EAEA,iBAAA;AA1CA;AA4CA;EAEA,yBAAA;EACA,yBAAA;AA3CA;AA8CC;EAED,wBAAA;EACA,eAAA;EACA,yBAAA;EACA,kBAAA;EACA,cAAA;EACA,sBAAA;EACA,4BAAA;EACA,iCAAA;EACA,wBAAA;EACA,6BAAA;EACA,0BAAA;EACA,SAAA;AA7CA;AA8CC;EAAK,cAAA;AA3CN;;AA8CA;EAEA,iCAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;EACA,gBAAA,EAAA,KAAA;EACA,kBAAA;AA5CA;;AA8CA;EAEA,aAAA;EACA,8BAAA;EACA,SAAA;EACA,gBAAA,EAAA,KAAA;AA5CA;AA6CC;EAGD,cAAA;EACA,YAAA;EACA,gBAAA;EACA,YAAA;EACA,yBAAA;EACA,mBAAA;EACA,2BAAA;EACA,4BAAA;EACA,gBAAA;EACA,mBAAA;EACA,eAAA;EACA,kCAAA;AA7CA;AAiCA;EAAS,yBAAA;AA9BT;;AA8CA;EAEA;IAEA,qBAAA;IACA,mBAAA;EA7CE;EA+CF;IAEA,mBAAA;IACA,2BAAA;IACA,kBAAA;EA9CE;EAgDF;IAEA,2BAAA;IACA,qBAAA;EA/CE;AACF;AAkDA;EAEA;IAEA,gBAAA,EAAA,KAAA;EAlDE;EAoDF;IAEA,sBAAA;EAnDE;EAqDF;IAEA,kBAAA,EAAA,SAAA;IACA,UAAA;EApDE;EAsDF;IAEA,mBAAA;IACA,uCAAA,EAAA,MAAA;EArDE;EAuDF;IAEA,eAAA,EAAA,KAAA;IACA,iBAAA;IACA,gBAAA,EAAA,MAAA;EAtDE;EAwDF;IAEA,sBAAA;IACA,gBAAA,EAAA,KAAA;IACA,kBAAA;EAvDE;EAyDF;IAEA,eAAA;IACA,iBAAA;EAxDE;EA0DF;IAEA,eAAA;EAzDE;EA2DF;IAEA,eAAA;IACA,iBAAA,EAAA,KAAA;IACA,eAAA,EAAA,MAAA;EA1DE;EA4DF;IAEA,gBAAA,EAAA,KAAA;EA3DE;EA6DF;IAEA,uBAAA;IACA,iBAAA;EA5DE;EA8DF;IAEA,eAAA;IACA,gBAAA;EA7DE;EA+DF;IAEA,mBAAA;IACA,4BAAA;IACA,YAAA;IACA,YAAA;IACA,QAAA;IACA,eAAA;IACA,kBAAA;IACA,gBAAA;EA9DE;EAgEF;IAEA,WAAA;EA/DE;EAiEF;IAEA,mBAAA;IACA,4BAAA;IACA,YAAA;IACA,YAAA;IACA,eAAA;IACA,gBAAA;EAhEE;EAiED;IAED,WAAA;EAhEE;EAoEF;IAEA,aAAA;EAnEE;EAqEF;IAEA,mBAAA;IACA,gBAAA,EAAA,KAAA;EApEE;EAsEF;IAEA,eAAA;EArEE;EAuEF;IAEA,eAAA;IACA,gBAAA,EAAA,KAAA;IACA,gBAAA;EAtEE;EAwEF;IAEA,0BAAA;IACA,QAAA;IACA,gBAAA,EAAA,KAAA;EAvEE;EAwED;IAED,YAAA;IACA,YAAA;IACA,sBAAA;EAvEE;AACF;AA0EA,sBAAA;AACA,SAAA;AACA;;;;;;;;;;;EAAA;AAYA;EAEA,kBAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,gBAAA;EACA,2DAAA;AAzEA;AA0EC;EAED,+BAAA;EACA,eAAA;EACA,iBAAA;EACA,kBAAA;EACA,cAAA;EACA,gBAAA;EACA,oBAAA,EAAA,QAAA;AAzEA;AA2EC;EAED,+BAAA;EACA,eAAA;EACA,iBAAA;EACA,kBAAA;EACA,cAAA;EACA,oBAAA,EAAA,QAAA;AA1EA;AA4EC;EAED,iCAAA;EACA,eAAA;EACA,iBAAA;EACA,kBAAA;EACA,cAAA;EACA,gBAAA;EACA,gBAAA;AA3EA;AA4EA;EAAM,cAAA;AAzEN;;AA6EC;EAED,aAAA;EACA,uBAAA;EACA,gBAAA,EAAA,QAAA;AA3EA;AA4EE;EAGF;6FAAA;EAIA,kBAAA;EACA,WAAA;AA9EA;AAwEA;EAAa,iBAAA;AArEb;AAwEA;EAAa,mBAAA;AArEb;AAsEA;EAAK,2BAAA;EAA4B,kBAAA;AAlEjC;;AAuEA,aAAA;AAEA;EAEA;IAEA,gBAAA;EAvEE;EAyEF;IAEA,gBAAA;EAxEE;EA0EF;IAEA,WAAA,EAAA,KAAA;IACA,kBAAA,EAAA,KAAA;EAzEE;EA2EF;IAEA,eAAA;IACA,iBAAA;IACA,oBAAA,EAAA,KAAA;IACA,gBAAA,EAAA,QAAA;EA1EE;EA4EF;IAEA,eAAA;IACA,iBAAA;IACA,oBAAA,EAAA,QAAA;EA3EE;AACF;AA+EA,oBAAA;AACA,gBAAA","sourcesContent":["/*reset all*/\n*,\n*::before,\n*::after {\n  box-sizing: border-box;\n\tvertical-align: baseline;\n\tfont-weight: inherit;\n\tfont-family: inherit;\n\tfont-style: inherit;\n\tfont-size: 100%;\n\tborder: 0 none;\n\toutline: 0;\n\tpadding: 0;\n\tmargin: 0;\n}\n\n\nul[class],\nol[class] {\n  padding: 0;\n}\n\n\nbody,\nh1,\nh2,\nh3,\nh4,\np,\nul[class],\nol[class],\nli,\nfigure,\nfigcaption,\nblockquote,\ndl,\ndd {\n  margin: 0;\n}\nH1,H2,H3,H4,H5,H6\n{\nfont-size:inherit;\nline-height:inherit;\nfont-weight:inherit;\nmargin:0;\npadding:0;\n}\n\n\nbody {\n  min-height: 100vh;\n  scroll-behavior: smooth;\n  text-rendering: optimizeSpeed;\n  line-height: 1.5;\n}\n\n\nul[class],\nol[class] {\n  list-style: none;\n}\n\n\na:not([class]) {\n  text-decoration-skip-ink: auto;\n}\n\n\nimg {\n  max-width: 100%;\n  display: block;\n}\n\n\narticle > * + * {\n  margin-top: 1em;\n}\n\n\ninput,\nbutton,\ntextarea,\nselect {\n  font: inherit;\n}\nA\n{\noutline:none;\ntext-decoration:none;\n}\nINPUT, TEXTAREA\n{\noutline:none;\n}\n/*end reset all*/","@import \"./variables.scss\";\nbody > iframe {\n  display: none;\n}\n:root {\n  --font-family: 'fs_eliot';\n  --second-family:  'goodtimes';\n  --third-family: 'Atom-Regular';\n  --font3: 'Atom-Regular';\n}\n@keyframes fadeIn {\n    0% {\n        opacity: 0;\n    }\n    100% {\n        opacity: 1;\n    }\n}\n@keyframes deColor {\n    0% {\nfilter:brightness(1);\n    }\n   50% {\nfilter:brightness(1.75);\n    }\n    100% {\nfilter:brightness(1);\n    }\n}\n@keyframes deColor1 {\n    0% {\nfilter:brightness(1);\n    }\n   16.5% {\nfilter:brightness(1.75);\n    }\n    33% {\nfilter:brightness(1);\n    }\n}\n@keyframes deColor2 {\n    33% {\nfilter:brightness(1);\n    }\n   49.5% {\nfilter:brightness(1.75);\n    }\n    66% {\nfilter:brightness(1);\n    }\n}\n@keyframes deColor3 {\n    66% {\nfilter:brightness(1);\n    }\n   82.5% {\nfilter:brightness(1.75);\n    }\n    100% {\nfilter:brightness(1);\n    }\n}\nbody\n{\nbackground-color:#CCCF2C;/*#1E1E1E*/\ncolor:#040628;\n/*\nbackground-image:url('/i/bg_footer.svg');\nbackground-repeat:no-repeat;\nbackground-size:contain;*/\n}\n.show\n{\nopacity:1 !important;\n}\n.disable_scroll\n{\noverflow:hidden;\n}\n.hide\n{\ndisplay:none !important;\n}\n.head_block\n{\nposition:relative;\n/*background-image:url('/i/black_hole 2.png');*/\nbackground-repeat:no-repeat;\nbackground-size:100vw;/*100vw, 100%/\n/*border-bottom:1px solid rgba(255,255,255,0.2);*/\n/*background: linear-gradient(0deg, #cccf2c 0%, #fdff8a 100%);*/\n/*background: linear-gradient(0deg, rgba(204,207,44, 0.5) 0%, rgba(253,255,138, 0.5) 100%);*/\nbackground-image:url('/i/main_1_leto_bg_grad.svg');\nbackground-position:center; /*center 0%, center*/\nmin-height:624px;\n}\n.head_bg\n{\nposition:absolute;\ntop:0px;\nleft:0px;\nbackground: linear-gradient(0deg, rgba(204,207,44, 0) 0%, rgba(253,255,138, 0.5) 100%); /*background: linear-gradient(0deg, rgba(204,207,44, 0.5) 0%, rgba(253,255,138, 0.5) 100%);*/\nbackground-size:100%;\nwidth:100%;\nheight:70%;\n}\n.head_block_1\n{\ndisplay:flex;\nflex-direction:column;\njustify-content:space-between;\nalign-items:center;\npadding-top:159px /*151*/;\n/*background-image: url('/i/main_1_leto_bg.png');*/\nbackground-repeat:no-repeat;\nbackground-size:clamp(500px, 100%, 1031px);\nbackground-position:center 243px; /*235 151*/\n\t.title\n\t{\nfont-family: var(--second-family);\nfont-size: 70px;\nline-height: 76%;\ncolor: #fbff6c;\n\t}\n\t.head_block_text_img\n\t{\nwidth:100%;\nmax-width:1061px;\nmargin-top:15px;\n\t}\n}\n.head_block_1_wrapper\n{\nposition:relative;\ntop:-27px;/*-30*/\n/*top:-220px; -220px*/\ndisplay:flex;\njustify-content:center;\nalign-items:flex-end;\n\t.small_image\n\t{\ndisplay:flex;\nalign-items:flex-end;\nmargin-bottom:40px;\n\t\t.title\n\t\t{\nfont-family: var(--font3);\nfont-weight: 400;\nfont-size: 27px;\nline-height: 100%;\ncolor: #040628;\n\t\t}\n\t\tIMG\n\t\t{\nmax-height:89px;\nheight:100%;\n\t\t}\n\t}\n\t.column_1\n\t{\n\tposition:relative;\n\tleft:max(8%,21px); /*10% 127px*/\n\tflex-shrink:0;\n\tIMG {margin-right:18px;}\n\t}\n\t.column_2 IMG\n\t{\n\tmax-height:max(calc( 100vh - 298px ),300px);/*100vh - 268px  740px*/\n/*\tmin-height:300px;*/\n\t}\n\t.column_3\n\t{\n\tposition:relative;\n\tright:max(8%,21px); /*10% 127px*/\n\tflex-shrink:0;\n\t.title {text-align:right;}\n\tIMG {margin-left:6px;}\n\t}\n\t\n}\n.head_block_2\n{\ndisplay:flex;\nalign-items:center;\njustify-content:center;\nflex-direction:column;\nposition:relative;\nmargin-top:33px;\noverflow:visible;\nz-index:0;\n\t.text\n\t{\nfont-family: 'Atom-Light';\nfont-size:24px;\nline-height:29px;\ntext-align:center;\ncolor:#040628;\nmax-width:calc(867px + 46px + 46px);\npadding-left:46px;\npadding-right:46px;\n\t\tSPAN {font-family: 'Atom-Bold';}\n\t}\n}\n\n/*responsive header*/\n@media all and (max-width:1109px)/*1050 1027*/\n{\n\n.head_block_1\n{\npadding-top:100px;\nbackground:none;\n}\n.head_block_1 .title\n{\n&:first-child\n{\npadding-left:30px;\npadding-right:0px;\n}\nfont-size: 32px; /*40*/\nline-height: 100%;\ncolor: #fbff6c;\ntext-align:center;\npadding-left:0px;\npadding-right:30px;\n}\n.head_block_1_wrapper\n{\ntop:0px;\nmargin-top:15px;/*24*/\n}\n.head_block_text_img\n{\ndisplay:none;\n}\n\n}\n@media all and (max-width:991px)\n{\n\n.head_block_1_wrapper .small_image .title\n{\nfont-size: 21px;\nline-height: 105%;\ncolor: #040628;\ntext-align:right;\npadding-left:0px;\npadding-right:0px;\n}\n.head_block_1_wrapper .column_1\n{\nleft:30px;\n}\n.head_block_1_wrapper .column_3\n{\nright:30px;\n}\n.head_block_1_wrapper .column_1 IMG\n{\nmax-height:71px;\nmargin-right: 14px;\n}\n.head_block_1_wrapper .column_2 IMG\n{\nmax-height:unset;\n}\n.head_block_1_wrapper .column_3 IMG\n{\nmax-height:73px;\nmargin-left:5px;\n}\n.head_block_2 .text\n{\nfont-size: 14px;\nline-height:1.25;\ncolor: #040628;\npadding-left:30px;\npadding-right:30px;\n}\n\n}\n\n@media all and (max-width:750px) /*650*/\n{\n.head_block_1 .title\n{\ntext-align:left;\n}\n.head_block_1_wrapper\n{\nflex-direction:column;\nalign-items:center;\n}\n\n.head_block_1_wrapper .column_1\n{\norder:2;\nleft:unset;\nalign-self: flex-start;\npadding-left:28px;\n}\n.head_block_1_wrapper .column_2\n{\norder:1;/*\nheight:50vh;\nwidth:100vw;\nbackground-image: url('/i/main_bg_mob.png');\nbackground-repeat:no-repeat;\nbackground-size:cover;\nbackground-position:center;\n\tIMG {display:none;}*/\n}\n.head_block_1_wrapper .column_3\n{\norder:3;\nright:unset;\nalign-self: flex-end;\npadding-right:21px;\n}\n.head_block_1_wrapper .small_image\n{\nmargin-bottom:10px;\n}\n\n}\n/*end responsive header*/\n/*download block*/\n.download_1\n{\nposition:relative;\npadding:24px;\npadding-top:0px;\nwidth:100%;\nmax-width:938px;\nheight:402px;\nbackground: rgba(203, 207, 44, 0.9);\nborder-radius: 30px;\nmargin:0 auto;\nmargin-top:127px; /*97*/\n/*background-color:orange;*/\noverflow:visible;/*\n&::before\n{\n  content: \"\";\n  position: absolute;\n  width: 100%;\n  height: 100%;\n  top: -50%;\n  left: -50%;\n  z-index: -1;\n  background-image:url('/i/glow_bg_app_store.png');\n}*/\n\t.qr\n\t{\nposition:absolute;\nbottom:28px;\nright:28px;\nz-index:1;\npointer-events:none;\nmax-width:219px;\n\t}\n\t.glow\n\t{\nposition:absolute;\ntop:-50%; /*70%*/\nleft:0px;\nright:0px;\nz-index:-2;\n\t}\n\t.mobile\n\t{\nwidth:471px;/*460 545*/\nposition:absolute;\ntop:-44px; /*-19%*/\nright:180px;\nz-index:1;\ntransition:0.5s opacity linear;\nopacity:0;\npointer-events:none;\n\t}\n\t.button_wrapper\n\t{\nmargin-left:13px;\n\t}\n\t.button\n\t{\ndisplay:block;\nmax-width:256px;\nheight:45px;\nbackground-color:#202020;\nborder-radius:10px;\nbackground-position:center;\nbackground-repeat:no-repeat;\npadding-top:7px;\npadding-bottom:7px;\nmargin-top:7px;/*16*/\ncursor:pointer;\ntransition:0.3s background linear;\n\t}\n\t.button:hover\n\t{\nbackground-color:#A99C56;\n\t}\n\t.button:first-child\n\t{\nmargin-top:92px;/*50*/\n\t}\n\t\t.image\n\t\t{\nmax-width:355px;\nmargin-left:13px;/*37*/\npadding-top:34px;\nwidth:100%;\nopacity:0;\ntransition:0.5s opacity linear;\n\t\t}\n\t.wrapper\n\t{\ndisplay:flex;\n\t}\n}\n/*responsive download*/\n@media all and (max-width:991px)\n{\n\n.download_1\n{\nmargin-top:40px;/*47*/\npadding-left:0px;\npadding-right:0px;\nmax-width:263px;/*328 255*/\nheight:237px;/*278 235*/\nbackground-image:url('/i/bg_download1_mobile.svg');\n}\n.download_1 .qr\n{\ndisplay:none;\n}\n.download_1 .image\n{\npadding-top:19px;\nmax-width:194px; /*227*/\nmargin-left:19px;;\n}\n.download_1 .glow\n{\ndisplay:none;\n/*max-width:none;\nwidth:100vw;*/\n}\n.download_1 .button_wrapper\n{\ndisplay:flex;\njustify-content:center;\nalign-items:center;\nflex-direction:column;\nmargin:0 auto;\n}\n.download_1  .button:first-child\n{\nmargin-top:37px;\n}\n.download_1  .button\n{\nwidth:227px;\nheight:40px;\nbackground-size:88px;\npadding:6px;\n}\n.download_1 .mobile\n{\ndisplay:none;\n}\n\n}\n/*end responsive download*/\n/*end of download*/\n/*missions*/\n.missions\n{\nposition:relative;\ndisplay: flex;\nflex-direction:column;\nalign-items:center;\npadding-left:24px;\npadding-right:24px;\nbackground-image:/*url('/i/phone_1.png'), */url('/i/glow_bg_coins.svg');\nbackground-repeat:no-repeat;\nbackground-size:initial;/*cover*/\nbackground-position:/*left 572px, */center 0px; /*top right*/\noverflow:visible;\n\t.missions_bg\n\t{\nposition:absolute;\nleft:0px;\nbottom:-140px; /*-203*/\nmax-width:100%;\n\t}\n.missions_bg_bottom\n{\nposition:absolute;\nleft:0px;\nbottom:-30%;\nz-index:-2;\nmax-width:100%;\n}\n\t.title\n\t{\nfont-family: var(--second-family);\nfont-weight: 400;\nfont-size: 36px;\nline-height: 106%;\ntext-align: center;\ncolor: #040628;\ntext-transform:uppercase;\nmargin-top:159px; /*97*/\nwidth:100%;\n\tSPAN {font-family:'Atom-Bold';}\n\t}\n\t.text\n\t{\nfont-family:  'Atom-Light';\nfont-size: 24px;\nline-height:1.2;\ntext-align: center;\ncolor: #040628;\nmargin-top:32px;/*32*/\nmax-width:659px;/*904*/\nwidth:100%;\n\tB, STRONG {font-family:'Atom-Bold';}\n\t}\n}\n.missions_wrapper\n{\ndisplay:flex;\nalign-items:flex-start;\njustify-content:center;/*space-between*/\nmax-width:741px;\nmargin-top:68px;\nwidth:100%;\n\t.one:nth-child(2n) .image_bottom\n\t{\nwidth:370px;\nmax-width:none;\n\t}\n\t.one\n\t{\nposition:relative;\ndisplay:flex;\njustify-content:flex-start;\nalign-items:center;\nflex-direction:column;\nflex-shrink: 0;\nborder-radius: 30px;\nbackground: rgba(167, 171, 40, 0.9);\nmax-width:341px;\nwidth:100%;\nheight:398px;\n&:first-child {margin-top:53px; margin-right:59px;}\n\t\t.image\n\t\t{\nopacity:0;\ntransition:0.5s opacity linear;\n\t\t}\n\t\t.image_top\n\t\t{\nposition:absolute;\ntop:-46px;\n\t\t}\n\t\t.image_bottom\n\t\t{\nposition:absolute;\nbottom:-174px;\n\t\t}\n\t\t.title\n\t\t{\nfont-family: var(--second-family);\nfont-weight: 400;\nfont-size: 36px;\ncolor: #fbff6c;\ntext-transform:uppercase;\nmargin-top:72px;\n\t\t}\n\t\t.text\n\t\t{\nfont-family: var(--font3);\nfont-weight: 400;\nfont-size: 20px;\nline-height: 115%;\ntext-align: center;\ncolor: #ffffff;\nmargin-top:41px;/*39*/\nmax-width:280px;/*904*/\nwidth:100%;\n\t\t}\n\t}\n}\n/*responsive of missions*/\n@media all and (max-width:991px)/*801*/\n{\n\n.missions\n{\nbackground-image:none;\n}\n.missions  .missions_bg_bottom\n{\ndisplay:none;\n}\n.missions .one\n{\nposition:relative;\noverflow:visible;\n}\n.missions .one:after\n{\ncontent:'';\nposition:absolute;\n/*left:calc((100vw - 264px)/2*-1);*/\nbottom:-142px;\nbackground-image:url('/i/glow_bg_coins_small.svg');\nbackground-repeat:no-repeat;\nbackground-size:100%;\nbackground-position:center 0px;\nwidth:100%;\n/*height:219px;*/\naspect-ratio:1491/748;\npointer-events:none;\n}\n\n.missions .missions_bg\n{\nbottom:unset;\ntop:309px;\nmax-width:70%;\n}\n.missions .title\n{\nfont-size: 17px;\nline-height: 112%;\nmax-width:207px;\nmargin-top:45px;\n}\n.missions .text\n{\nfont-size: 14px;\nmargin-top:16px;\nmax-width:232px;\n}\n.missions_wrapper\n{\nmargin-top: 57px;\nflex-direction:column;\nalign-items:center;\noverflow:visible;\n\t.one \n\t{\n\t\t&:first-child\n\t\t{\nmargin-top:0px; margin-right:0px;\n.image_top {width:65px; top:-33px}\n.image_bottom {width:248px;/*190*/ bottom:-137px;  }\n\t\t}\nmargin-top:151px; /*57*/\nwidth:264px;\nheight:294px;\n\t.image_top {width:72px; top:-39px;}\n\t.text {max-width:196px;}\n      .image_bottom {max-width:100% !important;width:268px;/*190*/ bottom:-136px ;z-index:1; }\n\t}\n}\n.missions_wrapper .one .title\n{\nfont-size:27px;\nmargin-top:52px;\n}\n.missions_wrapper .one .text\n{\nfont-size: 14px;\nline-height: 121%;\nmargin-top:29px;\n}\n\n}\n@media all and (max-width:991px) and (min-width:625px)\n{\n\n.missions_wrapper\n{\nflex-direction:row;\ngap:20px;\n\t.one\n\t{\n&:first-child {margin-top:40px;}\nmargin-top:0px;\n\t}\n}\n\n}\n/*end responsive*/\n/*end of missions*/\n/*store*/\n.store\n{\ndisplay:flex;\nflex-direction:column;\nalign-items:center;\noverflow:visible;\nposition:relative;\n/*\nbackground-image:url('/i/milk 1.png');\nbackground-position:left -300px;\nbackground-repeat:no-repeat;\nbackground-size:100%;*/\n\t.store_bg\n\t{\nposition:absolute;\ntop:0px;/*-200*/\nright:0px;\nwidth:100%;\nmax-width:359px;\nz-index:-1;\n\t}\n\t.store_title\n\t{\nfont-family: var(--second-family);\nfont-weight: 400;\nfont-size: 36px;\nline-height: 106%;\ntext-align: center;\ncolor: #040628;\ntext-transform:uppercase;\nmargin-top:237px; \nwidth:100%;\n\tSPAN {font-family:'Atom-Bold';}\n\t}\n\t.store_subtitle\n\t{\nfont-family:  'Atom-Light';\nfont-size: 24px;\nline-height:1.2;\ntext-align: center;\ncolor: #040628;\nmargin-top:32px;/*32*/\nmax-width:659px;/*904*/\nwidth:100%;\n\tB, STRONG {font-family:'Atom-Bold';}\n\t}\n\t.wrapper_arrows\n\t{\ndisplay:flex;\njustify-content:space-between;\nalign-items:center;\nmargin-top:36px;\nmax-width:820px;\nwidth:100%;\n\t\t.item\n\t\t{\nfont-family: var(--second-family);\nfont-size: 36px;\nline-height: 106%;\ntext-align: center;\ncolor: #040628;\n\t\t}\n\t}\n\t.wrapper_top\n\t{\ndisplay:grid;\njustify-content:space-between;\nmargin-top:18px; /*19*/\nmax-width:1136px;\nwidth:100%;\ngrid-template-columns:1fr 1fr 1fr;\ngap: 7px;\n\t\t.one\n\t\t{\nposition:relative;\nz-index:1;\ndisplay:flex;\njustify-content:flex-start;\nalign-items:center;\nflex-direction:column;\nbackground-position:center;\nbackground-repeat:no-repeat;\nbackground-size:cover;\nwidth:100%;\nborder-radius:30px;\nmax-width:369px;\nheight:196px;\n.image\n{\nposition:absolute;\ntop:70px;\ndisplay:flex;\njustify-content:center;\nalign-items:center;\nmax-width:100%;\npointer-events:none;\n}\n\n.text\n{\nfont-family:  'Atom-Light';\nfont-size: 24px;\nline-height:1.2;\ntext-align: center;\ncolor: #ffffff;\nmargin-top:27px;/*28 32*/\nmax-width:300px;/*283 904*/\nwidth:100%;\n\tB, STRONG {font-family:'Atom-Medium';}\n}\n\t\t}\n\t}\n.store_wrapper_end\n{\nbackground-color:red;\nwidth:100%;\nheight:100px;\ngrid-column:3 span;\nclip-path: ellipse(125% 100% at top); \n}\n.store_big_wrapper\n{\nposition:relative;\ndisplay:flex;\nflex-direction:column;\nalign-items:center;\nbackground-color:#040628;\nwidth:100%;\npadding-bottom: 95px;/*176*/\npadding-top: 100px;\nmargin-top:43px;/*100*/\n\t&:after\n\t{\ncontent:'';\nposition:absolute;\nbottom:0px;\ntop:0px;\nbackground-color:#CCCF2C;\nwidth:100%;\nheight:100px;\nclip-path: ellipse(55% 100% at top); \n\t}\n}\n\t.title_count\n\t{\n\nfont-family:'Atom-Bold';\nfont-size:24px;\nline-height:28px;\ntext-transform: uppercase;\ntext-align:center;\ncolor:#ffffff;\nmargin-top:72px;/*77*/\nmax-width:401px;/*393*/\nwidth:100%;\n\t}\n\t.store_cards\n\t{\n/*display:flex;\nflex-wrap:wrap;*/\ndisplay:grid;\ngrid-auto-flow:dense;\ngrid-template-columns:255px 255px 255px 255px;\ngrid-gap:16px;\njustify-content:center;\nmax-width:calc( 1068px + 24px + 24px );\nwidth:100%;\nmargin-top:45px; /*29 36 45*/\npadding-left:24px;\npadding-right:24px;\n\t\t.slider_points\n\t\t{\ndisplay:flex;\njustify-content:center;\nalign-items:center;\nmargin-top:22px;/*10*/\n/*\nLI\n{\nwidth:9px;\nheight:9px;\nfont-size:20px;\nlist-style-type:circle;\nmargin-left:3px;\nmargin-right:4px;\ncursor:pointer;\n}*/\n.slider_point\n{\nwidth:8px;\nheight:8px;\nmargin-right:9px;/*10*/\nborder-radius: 50%;\nborder:1px solid #ffffff;\ntransition:0.3s all linear;\ncursor:pointer;\nbox-sizing:none;\n}\n.slider_point:last-child\n{\nmargin-right:0px;\n}\n.slider_point_active\n{\nborder:1px solid #FFFFFF;\nbackground-color:#FFFFFF;\n/*font-size:26px;\nline-height:29px;\ncolor:#48FFB2;\nlist-style-type:disc;*/\n}\n\t\t}\n\t}\n\t.store_card\n\t{\ngrid-column:span 1;\ndisplay:flex;\nflex-direction:column;\njustify-content: space-between;\n/*margin-right:16px;\nmargin-top:16px;*/\nwidth:255px;\nheight:440px;\nline-height:normal;\npadding-top:18px;\npadding-bottom:18px;\npadding-left:20px;/*23*/\npadding-right:20px;/*22*/\nbackground-repeat:no-repeat;\nbackground-size:100%;\ncursor:pointer;\n&:last-child {margin-right:0px;}\n&:nth-child(4) {margin-right:0px;}\n\t.store_card_wrapper_top\n\t\t{\n/*margin-top:22px;*/\n.title\n{\n.green {color:#48FFB2;}\nfont-family:'Atom-Medium';\nfont-size:24px;\ntext-transform:uppercase;\ncolor:#ffffff;\n}\n.subtitle\n{\ndisplay:flex; \nfont-family:'Atom-Medium';\nfont-size:32px;\nline-height:62%;\ncolor:#48ffb2;\nmargin-top:25px;/*26*/\nalign-items:flex-end;/*center*/\n\tIMG {margin-right:10px;/*11*/}\n\n}\n\t\t}\n\t\t.title_bottom\n\t\t{\nfont-family:var(--font-family);\nfont-size:20px;\nline-height:23px;\ncolor:#ffffff;\n/*margin-bottom:23px;*/\nSTRONG\n{\nfont-weight:700;\ntext-transform:uppercase;\n}\n\t\t}\n\t\t.title_bottom_out\n\t\t{\nfont-family:'Atom-Medium';\nfont-size:14px; /*15 9*/\nletter-spacing: 0.02em;\ntext-transform:uppercase;\ncolor:#000;\npadding-top:25px;\n\t\t}\n\t}\n\t.store_card_big\n\t{\ngrid-column: span 2;\nwidth:526px;\n\t}\n}\n/*responsive of store*/\n\n@media all and (max-width:1115px)\n{\n.store .store_cards\n{\nmax-width:845px;/*797*/\ngrid-template-columns:255px 255px 255px;\ngrid-auto-flow:dense;\n}\n\n}\n\n@media all and (max-width:991px)\n{\n.store .wrapper_arrows\n{\ndisplay:none;\n}\n.store .wrapper_top\n{\ngrid-template-columns:1fr;\ngap:55px;/*46 30*/\n\t.one\n\t{\nmax-width:264px;\nheight:140px;\njustify-self: center;\n\t\t.text\n\t\t{\nposition:relative;\nz-index:1;\nfont-size: 17px;\nmargin-top: 20px;\nmax-width:200px;\ntext-align:center;\n\t\t}\n\t\t.image\n\t\t{\ntop:50px;\nwidth:114px;\n\t\t}\n\t}\n\t.one:nth-child(2n) .image\n\t{\nwidth:160px; /*139*/\n/*transform: rotate(-13deg);*/\n\t}\n\t.one:nth-child(3n) .image\n\t{\ntop:60px;\nwidth:123px;\n\t}\n}\n.store .store_bg\n{\nposition:static;\nmargin-top:112px; /*90 70*/\nalign-self:flex-end;\nwidth:auto;\nmax-width:70%;\n}\n.store .store_title\n{\nfont-size: 17px;\nline-height: 112%;\nmax-width:207px;\nmargin-top:7px; /*45*/\n}\n.store .store_subtitle\n{\nfont-size: 14px;\nmargin-top:16px;\nmax-width:158px;\n}\n.store .wrapper_top\n{\nflex-direction:column;\nmargin-top:27px; /*36*/\n}\n.store .title_count\n{\nfont-size:14px;\nline-height:17px;\nmargin-top:53px;/*48 37*/\nmax-width:234px;/*229*/\n/*order:99;*/\n}\n.store .store_cards\n{\nmargin-top:24px; /*34 20*/\n}\n.store .store_big_wrapper\n{\npadding-top:10px;\npadding-bottom:37px;/*50*/\n}\n.store .store_big_wrapper:after\n{\nwidth:100%;\nheight:30px;\nclip-path: ellipse(50% 100% at top); \n}\n\n}\n\n@media all and (max-width:860px)/*828*/\n{\n\n.store .store_cards\n{\ngrid-template-columns:255px 255px;\nmax-width:574px;/*526*/\n}\n}\n\n@media all and (max-width:991px) and (min-width:625px)\n{\n\n.store .wrapper_top\n{\ngrid-template-columns: 1fr 1fr;\ngap:50px;\n}\n.store .wrapper_top .one\n{\n&:last-child\n{\ngrid-column:2 span;\n}\njustify-self:center;\n}\n\n}\n\n@media all and (max-width:600px)\n{\n\n.store .store_cards\n{\ndisplay:flex;\nflex-direction:column;\nalign-items:center;\n}\n.store .store_card\n{\nanimation-name:fadeIn;\nanimation-iteration-count:1;\nanimation-timing-function:linear;\nanimation-duration:1s;\nanimation-fill-mode:forwards;\nmargin-right:0 !important;\n}\n.store .store_card .title_bottom_out\n{\nfont-size:13px;\ntext-align:center;\n}\n\n}\n/*end responsive of store*/\n/*end of store*/\n/*change block*/\n.change_wrapper\n{\nbackground-color:#040628;\n}\n.change\n{\ndisplay:flex;\nflex-direction:column;\nalign-items:center;\nmargin-top:0px;/*65*/\nline-height:normal;\nbackground-color:#CBCF2C;\nclip-path: ellipse(150% 100% at bottom); /*125 80%*/\n\n\t.title_change\n\t{\nfont-family: var(--second-family);\nfont-weight: 400;\nfont-size: 36px;\nline-height: 106%;\ntext-align: center;\ncolor: #040628;\ntext-transform:uppercase;\nmargin-top:79px;/*65*/\nwidth:100%;\n\tSPAN {font-family:'Atom-Bold';}\n}\n\t.text_change\n\t{\nfont-family:  'Atom-Light';\nfont-size: 24px;\nline-height:1.2;\ntext-align: center;\ncolor: #040628;\nmargin-top:32px;/*32*/\nmax-width:634px;/*904*/\nwidth:100%;\n\t}\n}\n\n.change_button\n{\ndisplay:flex;\nalign-items:center;\njustify-content:center;\nflex-direction:row;\ngap:10px;\nborder-radius: 40px;\npadding: 22px 29px 19px 29px;\nwidth:361px;\nheight:79px;\nbackground: linear-gradient(184deg, #040628 0%, #282e95 100%);\nmargin-top:44px;\nfont-family:'Atom-Medium';\nfont-size:21px;\ncolor:#ffffff;\ntransition:0.3s all linear;\nfilter:brightness(1);\n}\n.change_button:hover\n{\nfilter:brightness(1.2);\n}\n\n\n@media all and (max-width:991px)\n{\n\n.change .title_change\n{\nfont-size: 17px;\nline-height: 112%;\nmax-width:207px;\nmargin-top:42px; /*45*/\n}\n.change .text_change\n{\nfont-size: 14px;\nmargin-top:16px;\nmax-width:189px;/*232*/\n}\n\n}\n\n.change_big_wrapper\n{\ndisplay:flex;\nwidth:100%;\n\t.change_big\n\t{\ndisplay:flex;\njustify-content:flex-end;\nwidth:100%;\n\t}\n \t.change_big_img\n \t{\nposition:relative;\ntop:-150px;\nmax-width:min(728px,100%);/*min(992px,100%)*/\nheight: max-content;\nz-index:-1;\naspect-ratio:728/862;\n \t}\n}\n.change_wrapper1\n{\ndisplay:flex;\nmargin-top:65px; /*58*/\nmargin-bottom:86px;\nwidth:100%;\nflex-direction:column;\n\t.column1\n\t{\ndisplay:flex;\nflex-direction:column;\npadding-left:30px;\n\t.top_symbol\n{\ndisplay:flex;\nalign-items:flex-start;\njustify-content:center;\n\t\t.word\n\t\t{\nfont-family:var(--second-family);\nfont-size:96px;\nline-height:86px;\ntext-align:center;\ncolor:#ffffff;\n\t\t}\n\t\t.word2\n\t\t{\nfont-family:var(--second-family);\nfont-size:15px;\ntext-align:center;\ncolor:#ffffff;\nmargin-left:3px;\n\t\t}\n}\n.text\n{\nfont-family:var(--font-family);\nfont-size:24px;\ntext-align:center;\ncolor: #040628;\nmargin-top:10px;/*29*/\n\t.bold {font-family:'Atom-Bold'}\n}\n\t}\n\t\t.column2\n\t\t{\ndisplay:flex;\njustify-content:space-between;\nflex-direction:column;\nalign-items:center;\nmargin-top:70px;\n\t.image\n\t{\nwidth:89px;\nfilter:brightness(1);\ntransition:0.3s all linear;\n\t}\n.image:HOVER\n{\nfilter:brightness(1.1);\n}\n\t.text\n\t{\nfont-family:var(--font-family);\nfont-size:24px;\ntext-align:center;\ncolor: #040628;\nmargin-top:22px;/*23*/\n\t.bold {font-family:'Atom-Bold'}\n\t}\n\t.button\n\t{\nfont-family: 'fs_eliot';\nfont-size:24px;\nfont-weight: 400;\ncolor: #fff;\ndisplay:flex;\nalign-items:center;\njustify-content:center;\nborder-radius:40px;\npadding:25px 32px 21px 32px;\nwidth:405px; /*100%*/\nmax-width:405px;\nheight:77px;/*79*/\nbackground:#a7ab28;\ncursor:pointer;\ntransition:0.3s all linear;\nmargin-top:49px;\n\t}\n\t.button:HOVER\n\t{\nbackground:#202020;\n\t}\n\t\t}\n}\n.change_qr\n{\n&:hover{transform:scale(1.5)}\ndisplay:block;\nwidth:269px;\nmargin:0 auto;\n/*margin-top:122px;*/\ntransition:1s transform linear;\n}\n.change_download\n{\nDIV:first-child\n{\ndisplay:flex;\nflex-direction:column;\n}\n\t\t.slider_points\n\t\t{\ndisplay:flex;\njustify-content:center;\nalign-items:center;\nmargin-top:43px;/*50 55*/\nmargin-bottom:17px; /*22*/\n.slider_point\n{\nwidth:8px;\nheight:8px;\nmargin-right:9px;/*10*/\nborder-radius: 50%;\nborder:1px solid #040628;\ntransition:0.3s all linear;\ncursor:pointer;\nbox-sizing:none;\n}\n.slider_point:last-child\n{\nmargin-right:0px;\n}\n.slider_point_active\n{\nborder:1px solid #040628;\nbackground-color:#040628;\n}\n\t\t}\n\t.change_download_text\n\t{\nfont-family: 'Atom-Bold';\nfont-size: 24px;\ntext-transform: uppercase;\ntext-align: center;\ncolor: #040628;\nanimation-name:fadeIn;\nanimation-iteration-count:1;\nanimation-timing-function:linear;\nanimation-duration:0.5s;\nanimation-fill-mode:forwards;\nmargin-right:0 !important;\norder:99;\n\tspan{color:#040628;}\n\t}\n}\n.change_play\n{\nfont-family: var(--second-family);\nfont-size:60px;\nline-height:100%;\ncolor: #040628;\nmargin-top:49px; /*75*/\ntext-align:center;\n}\n.change_button_wrapper\n{\ndisplay:grid;\ngrid-template-columns:1fr 1fr;\ngap:40px;\nmargin-top:36px; /*52*/\n\tA\n\t{\n&:hover{ background-color:#A99C56;}\ndisplay:block;\nwidth:380px;\nmax-width:380px;\nheight:67px;\nbackground-color:#202020;\nborder-radius:10px;\nbackground-position:center;\nbackground-repeat:no-repeat;\npadding-top:7px;\npadding-bottom:7px;\ncursor:pointer;\ntransition:0.3s background linear;\n\t}\n\t\n}\n@media all and (min-width:1922px)\n{\n.change_wrapper1\n{\nalign-items:flex-end;\npadding-right:50px;\n}\n.change_big_wrapper .change_big\n{\n/*max-width:992px;*/\njustify-content:flex-start;\npadding-left:50px;\n}\n.change_big_wrapper .change_big_img\n{\nmax-width:min(992px,100%);\naspect-ratio:992/862;\n}\n}\n\n@media all and (max-width:991px)\n{\n.change_download\n{\nmargin-top:20px; /*20*/\n}\n.change_big_wrapper\n{\nflex-direction:column;\n}\n.change_big_wrapper .change_big_img\n{\nposition:relative;/*static*/\ntop:-50px;\n}\n.change\n{\n/*margin-top:51px;*/\nclip-path: ellipse(250% 100% at bottom); /*200*/\n}\n.change .title_change\n{\nfont-size:17px; /*20*/\nline-height:21px;\nmax-width:unset;/*140*/\n}\n.change_wrapper1\n{\nflex-direction:column;\nmargin-top:41px;/*44*/\nmargin-bottom:0px;\n}\n.change_wrapper1 .column1 .top_symbol .word\n{\nfont-size:54px;\nline-height:58px;\n}\n.change_wrapper1 .column1 .top_symbol .word2\n{\nfont-size:11px;\n}\n.change_wrapper1 .column1 .text\n{\nfont-size:14px;\nline-height:17px;/*16*/\nmargin-top:1px;/*7 9*/\n}\n.change_wrapper1 .column2\n{\nmargin-top:37px; /*39*/\n}\n.change_wrapper1 .column1 .top_symbol\n{\njustify-content:center;\nmargin-left:44px;\n}\n.change_wrapper1 .column2 .text\n{\nfont-size:14px;\nmargin-top:12px/*14*/\n}\n.change_wrapper1 .column2 .button\n{\nborder-radius:21px;\npadding:13px 17px 11px 17px;\nwidth:261px;\nheight:49px;\ngap:5px;\nfont-size:15px;\nfont-weight:700px;\nmargin-top:24px;\n}\n.change_wrapper1 .column2 .image\n{\nwidth:56px;\n}\n.change_button\n{\nborder-radius: 25px;\npadding: 15px 20px 13px 20px;\nwidth: 261px;\nheight: 49px;\nfont-size: 15px;\nmargin-top:20px;\n\t.image\n\t{\nwidth:20px;\n\t}\n}\n\n.change_qr\n{\ndisplay:none;\n}\n.change_download .slider_points\n{\nmargin-bottom:11px;\nmargin-top:24px;/*62*/\n}\n.change_download .change_download_text\n{\nfont-size:14px;\n}\n.change_play\n{\nfont-size: 32px;\nmargin-top:34px;/*13*/\nmax-width:183px;\n}\n.change_button_wrapper\n{\ngrid-template-columns:1fr;\ngap:7px;\nmargin-top:16px;/*17*/\n\tA\n\t{\nwidth:227px;\nheight:40px;\nbackground-size:100px;\n\t}\n}\n}\n/*end of change block*/\n/*footer*/\n/*\n.footer:after\n{\nposition:absolute;\nbottom:0px;\ncontent:'';\nwidth:100%;\nheight:534px;\nbackground: linear-gradient(0deg, #fdff8a  0%, #cccf2c 100%);\nz-index:-1;\npointer-events:none;\n}*/\n.footer\n{\nposition:relative;\ndisplay:flex;\nflex-direction:column;\nalign-items:center;\nmargin-top:46px /*42*/;\nbackground: linear-gradient(0deg, #fdff8a  0%, #cccf2c 100%);\n\t.copy\n\t{\nfont-family:var(--font-family);\nfont-size:14px;\nline-height:150%;\ntext-align:center;\ncolor:#03062a;\nmargin-top:38px;\npadding-bottom:16px;/*32 30*/\n\t}\n\t.copy2\n\t{\nfont-family:var(--font-family);\nfont-size:14px;\nline-height:150%;\ntext-align:center;\ncolor:#03062a;\npadding-bottom:34px;/*32 30*/\n\t}\n\t.footer_title\n\t{\nfont-family:var(--second-family);\nfont-size:36px;\nline-height:139%;\ntext-align:center;\ncolor:#000000;\nmargin-top:73px;\nmax-width:765px;\nSPAN {color:#ffffff;}\n\t}\n}\n\n\t.footer_social\n\t{\ndisplay:flex;\njustify-content:center;\nmargin-top:41px;/*86 84*/\n\t\tA\n\t\t{\n&:last-child{margin-right:0px;}\n/*&:hover IMG {filter: drop-shadow(10px 10px 10px #A99C56) invert(0%);}\nIMG {transition:0.3s all linear; filter: drop-shadow(0px 0px 0px transparent) invert(0%);}*/\n&:hover IMG {filter: invert(10%);}\nIMG {transition:0.3s all linear; filter: invert(0%);}\nmargin-right:28px;\nwidth:31px;\n\t\t}\n\t}\n/*responsive*/\n\n@media all and (max-width:991px)\n{\n.footer\n{\nmargin-top:20px;\n}\n.footer_social\n{\nmargin-top:21px;\n}\n.footer_social A\n{\nwidth:31px; /*31*/\nmargin-right:17px; /*41*/\n}\n.footer .copy\n{\nfont-size:10px;\nline-height:15px; \npadding-bottom:18px;/*20*/\nmargin-top:65px;/*47 46*/\n}\n.footer .copy2\n{\nfont-size:12px;\nline-height:15px; \npadding-bottom:20px;/*18 20*/\n}\n\n\n}\n/*end of responsive*/\n/*end of footer*/","@import \"./scss_base/_reset.scss\";\n/*colors*/\n$blue:#1458A3;\n/*end of colors*/\n@mixin return_font($family,$size,$line-height,$color)\n{\n  font: {\n     @if $family!='' {family: $family;}\n     @if $size!='' {    size: #{$size};}\n  \t\t}\n     @if $color!='' {color:#{$color};}\n     @if $line-height!='' {line-height:#{$line-height};}\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
